export default {
  'header.homepage': 'Página Principal',
  'header.workspace': 'Espacio de Trabajo',
  'login.title': 'Seedance',
  'login.welcome': 'Bienvenido a Seedance',
  'login.description': 'Seedance es tu plataforma de generación de video con IA. Servicios seguros y convenientes. Accede a todos tus archivos en cualquier momento y lugar.',
  'login.email.placeholder': 'Correo o nombre de usuario',
  'login.password.placeholder': 'Contraseña',
  'login.button': 'Iniciar sesión',
  'login.loading': 'Iniciando sesión...',
  'login.divider': 'o',
  'login.signup': '¿No tienes cuenta?',
  'login.signup.link': 'Regístrate',
  'login.error.default': 'Error al iniciar sesión, por favor inténtalo más tarde',
  'login.success': 'Sesión iniciada',
  'login.forgotPassword': '¿Olvidaste tu contraseña?',
  'login.forgotPassword.link': 'Restablecer aquí',
  'login.rememberPassword': 'Recordar contraseña',
  'login.social.comingSoon': 'Este método de inicio de sesión estará disponible pronto',
  'captcha.placeholder': 'Código captcha',
  'captcha.refresh': 'Actualizar captcha',
  'auth.modal.title': 'Inicio de sesión requerido',
  'auth.modal.content': 'Su sesión ha expirado o no ha iniciado sesión. Por favor, inicie sesión para continuar.',
  'auth.modal.ok': 'Ir a iniciar sesión',
  'auth.modal.cancel': 'Más tarde',
  'signup.page.title': 'Registro - Seedance',
  'signup.title': 'Seedance',
  'signup.welcome': 'Bienvenido a Seedance',
  'signup.description': 'Crea tu cuenta y comienza tu viaje de creación con IA',
  'signup.feature.ai': 'Impulsado por IA',
  'signup.feature.video': 'Creación de Video',
  'signup.feature.fast': 'Generación Rápida',
  'signup.feature.creative': 'Creatividad Ilimitada',
  'signup.username.placeholder': 'Ingresa nombre de usuario',
  'signup.email.placeholder': 'Ingresa correo',
  'signup.password.placeholder': 'Ingresa contraseña',
  'signup.confirmPassword.placeholder': 'Confirma contraseña',
  'signup.inviteCode.placeholder': 'Código de invitación (opcional)',
  'signup.button': 'Registrarse',
  'signup.loading': 'Registrando...',
  'signup.login': '¿Ya tienes cuenta?',
  'signup.login.link': 'Inicia sesión',
  'signup.error.passwordMismatch': 'Las contraseñas no coinciden',
  'signup.error.default': 'Error al registrarse, por favor inténtalo más tarde',
  'signup.success': 'Registro exitoso',
  'signup.username.rule.length': 'El nombre de usuario debe tener entre 4 y 10 caracteres',
  'signup.username.rule.format': 'Solo se permiten letras, números, guiones bajos y guiones',
  'signup.password.rule.length': 'La contraseña debe tener entre 6 y 20 caracteres',
  'signup.password.rule.lowercase': 'Debe contener letras minúsculas',
  'signup.password.rule.uppercase': 'Debe contener letras mayúsculas',
  'signup.password.rule.number': 'Debe contener números',
  'signup.password.rule.special': 'Debe contener caracteres especiales',
  'resetPassword.page.title': 'Restablecer contraseña - Seedance',
  'resetPassword.page.description': 'Restablece tu contraseña de cuenta Seedance',
  'resetPassword.title': 'Restablecer contraseña',
  'resetPassword.email.placeholder': 'Ingresa tu correo electrónico',
  'resetPassword.code.placeholder': 'Ingresa el código de verificación',
  'resetPassword.password.placeholder': 'Ingresa nueva contraseña',
  'resetPassword.button': 'Restablecer',
  'resetPassword.button.loading': 'Restableciendo...',
  'resetPassword.backToLogin': 'Volver al inicio de sesión',
  'resetPassword.sendCode': 'Obtener código',
  'resetPassword.sendCode.sending': 'Enviando...',
  'resetPassword.sendCode.retry': 'Reintentar en {seconds}s',
  'resetPassword.error.emailRequired': 'Por favor ingresa tu correo electrónico',
  'resetPassword.error.codeRequired': 'Por favor ingresa el código de verificación',
  'resetPassword.error.passwordRequired': 'Por favor ingresa una nueva contraseña',
  'resetPassword.error.passwordLength': 'La contraseña debe tener entre 6 y 20 caracteres',
  'resetPassword.error.codeLength': 'El código de verificación debe tener 6 dígitos',
  'resetPassword.success.codeSent': 'El código de verificación ha sido enviado a tu correo',
  'resetPassword.success.reset': 'Contraseña restablecida con éxito',
  'resetPassword.error.sendFailed': 'Error al enviar el código de verificación, por favor intenta más tarde',
  'resetPassword.error.resetFailed': 'Error al restablecer la contraseña, por favor intenta más tarde',
  'resetPassword.error.incomplete': 'Por favor completa todos los campos requeridos',
  'resetPassword.subtitle': 'Ingresa tu correo electrónico y una nueva contraseña para restablecer el acceso a tu cuenta.',
  'resetPassword.email.label': 'Correo electrónico',
  'resetPassword.code.label': 'Código de verificación',
  'resetPassword.password.label': 'Nueva contraseña',
  'resetPassword.success.title': 'Restablecimiento exitoso',
  'resetPassword.success.description': 'Tu contraseña ha sido actualizada exitosamente. Ahora puedes iniciar sesión con tu nueva contraseña.',
  'resetPassword.goToLogin': 'Iniciar sesión',
  'resetPassword.promo.title': 'Protege tu cuenta, cuida tu creatividad.',
  'resetPassword.promo.description': 'Implementamos protocolos de seguridad de nivel bancario para garantizar que tus datos y creaciones sean exclusivamente tuyos.',
  'signup.verificationCode.placeholder': 'Ingrese el código de verificación',
  'signup.verificationCode.send': 'Obtener código',
  'signup.verificationCode.sending': 'Enviando...',
  'signup.verificationCode.retry': 'Reintentar en {seconds}s',
  'signup.verificationCode.success': 'Código de verificación enviado',
  'signup.verificationCode.error': 'Error al enviar el código',
  'signup.verificationCode.required': 'Por favor ingrese el código de verificación',
  'signup.verificationCode.invalid': 'Formato de código de verificación no válido',
  'signup.error.emailRequired': 'Por favor, introduce tu dirección de correo electrónico',
  'signup.announcement': '¡La función de registro está en mantenimiento hoy!',
  'sidebar.create': 'Crear',
  'sidebar.allFiles': 'Todos los archivos',
  'sidebar.starred': 'Favoritos',
  'sidebar.folders': 'Carpetas',
  'sidebar.trash': 'Papelera',
  'sidebar.decrypt': 'Herramienta de descifrado',
  'sidebar.promptMarket': 'Prompt Market',
  'sidebar.channels': 'Canales',
  'sidebar.dailyChallenge': 'Desafío Diario',
  'sidebar.mediaTools': 'Herramientas de Medios',
  'sidebar.storageNodes': 'Nodos de Almacenamiento',
  'create.tab.textToImage': 'Texto a Imagen',
  'create.tab.textToVideo': 'Texto a Video',
  'create.tab.imageToImage': 'Imagen a Imagen',
  'create.tab.imageToVideo': 'Imagen a Video',
  'create.tab.seedanceVideo': 'Seedance Imagen a Video',
  'create.seedance.title': 'Seedance Imagen a Video',
  'create.seedance.subtitle': 'ByteDance Doubao Seedance 1.5, generación de vídeos cortos impulsada por imagen',
  'create.seedance.noModel': 'No hay modelos Seedance disponibles. Configure en el panel de administración.',
  'create.seedance.cameraFixed': 'Cámara fija',
  'create.seedance.cameraFixed.true': 'Sí (fija)',
  'create.seedance.cameraFixed.false': 'No (dinámica)',
  'create.seedance.watermark': 'Añadir marca de agua',
  'create.seedance.watermark.true': 'Sí',
  'create.seedance.watermark.false': 'No',
  'create.textToImage.title': 'Texto a Imagen',
  'create.textToImage.subtitle': 'Ingrese una descripción y deje que la IA dibuje la imagen en su mente',
  'create.textToImage.description': 'Generar imágenes a partir de descripciones de texto. Esta función está en desarrollo...',
  'create.textToVideo.title': 'Texto a Video',
  'create.textToVideo.subtitle': 'Ingrese descripciones de escenas y controles de cámara para generar videos de alta calidad',
  'create.textToVideo.description': 'Generar videos a partir de descripciones de texto. Esta función está en desarrollo...',
  'create.imageToImage.title': 'Imagen a Imagen',
  'create.imageToImage.description': 'Generar nuevas imágenes a partir de imágenes de referencia. Esta función está en desarrollo...',
  'create.imageToVideo.title': 'Imagen a Video',
  'create.imageToVideo.description': 'Generar videos a partir de imágenes de referencia. Esta función está en desarrollo...',
  'sidebar.feedback': 'Comentarios',
  'sidebar.about': 'Acerca de',
  'sidebar.productLog': 'Actualizaciones',
  'promptMarket.title': 'Prompt Market',
  'promptMarket.subtitle': 'Explora las recetas de inspiración IA de los mejores creadores y libera tu potencial creativo',
  'promptMarket.searchPlaceholder': 'Buscar prompts, estilos, modelos...',
  'promptMarket.search': 'Buscar',
  'promptMarket.all': 'Todo',
  'promptMarket.tabAll': 'Recomendado',
  'promptMarket.tabImage': 'Texto a imagen',
  'promptMarket.tabVideo': 'Texto a video',
  'promptMarket.tabAudio': 'Texto a música',
  'promptMarket.sortLatest': 'Más reciente',
  'promptMarket.sortHot': 'Popular',
  'promptMarket.sortSales': 'Más vendidos',
  'promptMarket.publish': 'Publicar',
  'promptMarket.empty': 'No hay listados. ¡Sé el primero en publicar!',
  'promptMarket.free': 'Gratis',
  'promptMarket.token': 'TOKEN',
  'promptMarket.loadFailed': 'Error al cargar',
  'promptMarket.listSuccess': 'Publicado correctamente',
  'promptMarket.listFailed': 'Error al publicar',
  'market.label': 'MERCADO DE PROMPTS',
  'market.h1': 'Libera tu',
  'market.h1.highlight': 'inteligencia creativa.',
  'market.sub': 'El destino premium para prompts de IA: imagen, vídeo y música. Recetas verificadas para OpenAI, Google, Midjourney, Runway, Kling, Luma, Suno, ElevenLabs y más. Deja de adivinar, empieza a crear.',
  'market.providers.title': 'Compatible con los principales modelos y plataformas',
  'market.card1.title': 'Integración instantánea',
  'market.card1.desc': 'Salta la curva de aprendizaje del prompt engineering. Importa prompts probados a tu flujo de trabajo con un clic.',
  'market.card2.title': 'Monetiza tu creatividad',
  'market.card2.desc': 'Convierte tus mejores prompts en ingresos pasivos. Únete a miles de creadores que ganan con su experiencia en IA.',
  'market.card3.title': 'Calidad verificada',
  'market.card3.desc': 'Cada listing es revisado y probado manualmente. Garantizamos resultados consistentes en distintos modelos.',
  'market.card4.title': 'Explora el laboratorio',
  'market.card4.desc': 'Descubre más de 10.000 activos generados por la comunidad.',
  'market.cta': 'Ir al Mercado de Prompts',
  'home.mediaTools.title': 'Herramientas de medios',
  'home.mediaTools.subtitle': 'Uso online, sin instalación. Procese fácilmente sus imágenes, vídeo y audio.',
  'home.mediaTools.toolSuffix': '',
  'home.mediaTools.imageCompress.title': 'Comprimir imagen',
  'home.mediaTools.imageCompress.description': 'Compresión inteligente manteniendo la calidad. Procesamiento por lotes.',
  'home.mediaTools.videoCompress.title': 'Comprimir vídeo',
  'home.mediaTools.videoCompress.description': 'Compresión eficiente con resolución y bitrate personalizables. Múltiples formatos.',
  'home.mediaTools.audioCompress.title': 'Comprimir audio',
  'home.mediaTools.audioCompress.description': 'Optimice el tamaño manteniendo la claridad. MP3, AAC y más.',
  'filelist.column.name': 'Nombre',
  'filelist.column.size': 'Tamaño',
  'filelist.column.updateTime': 'Modificado',
  'filelist.column.recycletime': 'Fecha de eliminación',
  'filelist.column.actions': 'Acciones',
  'filelist.total': 'Total {total} elementos',
  'filelist.action.upload': 'Subir',
  'filelist.action.newFolder': 'Nueva carpeta',
  'filelist.action.refresh': 'Actualizar',
  'filelist.action.search': 'Buscar archivos',
  'filelist.action.batchDownload': 'Descargar',
  'filelist.action.batchDelete': 'Eliminar',
  'filelist.action.download': 'Descargar',
  'filelist.action.preview': 'Vista previa',
  'filelist.action.rename': 'Renombrar',
  'filelist.selected': '{count} seleccionados',
  'page.cloudDrive.title': 'Mi unidad en la nube',
  'page.cloudDrive.description': 'AIMATEX Cloud Drive - Almacena y gestiona tus archivos de forma segura',
  'modal.fileUpload.title': 'Subir archivos',
  'modal.fileUpload.dragText': 'Arrastra archivos aquí o haz clic para subir',
  'modal.fileUpload.start': 'Iniciar subida',
  'modal.fileUpload.cancel': 'Cancelar',
  'modal.fileUpload.clear': 'Limpiar lista',
  'modal.fileUpload.encrypt': 'Cifrar seleccionados',
  'modal.fileUpload.addMore': 'Agregar',
  'modal.fileUpload.remove': 'Quitar',
  'modal.fileUpload.error.noSelection': 'Por favor selecciona archivos para quitar',
  'modal.fileUpload.error.noEncryption': 'Por favor selecciona archivos para cifrar',
  'modal.fileUpload.error.noClear': 'No hay archivos para limpiar',
  'modal.fileUpload.error.noStart': 'No hay archivos para subir',
  'modal.fileUpload.error.noCancel': 'No hay subidas en curso para cancelar',
  'modal.fileUpload.error.fileSize': 'Tamaño de archivo excedido',
  'modal.fileUpload.error.fileType': 'Tipo de archivo no soportado',
  'modal.fileUpload.error.maxCount': 'Número máximo de archivos excedido',
  'modal.fileUpload.duplicate.title': 'El archivo ya existe',
  'modal.fileUpload.duplicate.skip': 'Omitir',
  'modal.fileUpload.duplicate.replace': 'Reemplazar',
  'modal.fileUpload.duplicate.rename': 'Renombrar',
  'modal.fileUpload.status.pending': 'Pendiente',
  'modal.fileUpload.status.uploading': 'Subiendo',
  'modal.fileUpload.status.success': 'Completado',
  'modal.fileUpload.status.error': 'Error',
  'modal.fileUpload.status.cancelled': 'Cancelado',
  'modal.fileUpload.status.duplicated': 'Duplicado',
  'modal.fileUpload.table.filename': 'Nombre del archivo',
  'modal.fileUpload.table.size': 'Tamaño',
  'modal.fileUpload.table.status': 'Estado',
  'modal.fileUpload.table.progress': 'Progreso',
  'modal.fileUpload.table.actions': 'Acciones',
  'modal.fileUpload.speed': 'Velocidad de subida',
  'modal.fileUpload.remainingTime': 'Tiempo restante',
  'modal.fileUpload.total.progress': 'Progreso total',
  'modal.fileUpload.error.message': 'Error al subir: {message}',
  'modal.fileUpload.confirm.clear': '¿Quieres limpiar la lista de subida?',
  'modal.fileUpload.confirm.cancel': '¿Quieres cancelar la subida?',
  'modal.fileUpload.clear.mobile': 'Limpiar',
  'modal.fileUpload.encrypt.mobile': 'Cifrar',
  'modal.fileUpload.addMore.mobile': 'Agregar',
  'productLog.title': 'Actualizaciones del producto',
  'security.features.title': 'Características de seguridad',
  'security.features.localDecryption.title': 'Descifrado local',
  'security.features.localDecryption.description': 'Todas las operaciones de descifrado se realizan localmente en tu navegador, el contenido del archivo y la contraseña nunca salen de tu dispositivo',
  'security.features.militaryEncryption.title': 'Cifrado militar',
  'security.features.militaryEncryption.description': 'Utiliza el algoritmo de cifrado AES-256-CBC, el estándar de cifrado simétrico más seguro que puede resistir todos los ataques conocidos',
  'security.features.privacyProtection.title': 'Protección de privacidad',
  'security.features.privacyProtection.description': 'Mecanismo estricto de protección de privacidad, no se guardan contraseñas de descifrado, no se registra contenido de archivos',
  'security.features.smartDecryption.title': 'Descifrado inteligente por bloques',
  'security.features.smartDecryption.description': 'La tecnología de descifrado inteligente por bloques mejora significativamente la velocidad de descifrado mientras reduce el uso de memoria',
  'security.features.learnMore': 'Más información',
  'common.philosophy': 'La tecnología debe servir al pueblo',
  'security.features.modal.title': 'Detalles de características de seguridad',
  'security.features.modal.close': 'Cerrar',
  'decrypt.security.modal.title': 'Aviso de seguridad',
  'decrypt.security.modal.description': 'Todas las operaciones de descifrado se realizan localmente, tu contraseña y contenido del archivo nunca se enviarán al servidor',
  'decrypt.security.modal.vip.title': 'Como usuario VIP, puedes:',
  'decrypt.security.modal.vip.feature1': 'Descifrar archivos de cualquier tamaño',
  'decrypt.security.modal.vip.feature2': 'Usar descifrado inteligente por bloques para mejor eficiencia',
  'decrypt.security.modal.vip.feature3': 'Soportar descifrado por lotes de archivos grandes',
  'decrypt.security.modal.free.title': 'Importante: El proceso de descifrado requiere aproximadamente 3 veces el tamaño del archivo en memoria del navegador.',
  'decrypt.security.modal.free.feature1': 'Los usuarios gratuitos están limitados a 4GB por archivo',
  'decrypt.security.modal.free.feature2': 'Actualiza a VIP para descifrar archivos de cualquier tamaño',
  'decrypt.security.modal.free.feature3': 'Si el navegador se bloquea, considera actualizar a VIP para usar el descifrado por bloques',
  'security.diagram.plaintext.block1': 'Bloque de texto plano 1',
  'security.diagram.plaintext.block2': 'Bloque de texto plano 2',
  'security.diagram.ciphertext.block1': 'Bloque de texto cifrado 1',
  'security.diagram.ciphertext.block2': 'Bloque de texto cifrado 2',
  'security.diagram.key': 'Clave',
  'security.diagram.aes.encryption': 'Cifrado AES',
  'security.diagram.xor.operation': 'Operación XOR',
  'security.diagram.iv': 'Vector de inicialización',
  'decrypt.fileList.empty': 'No hay archivos, por favor agrega archivos para descifrar',
  'decrypt.fileList.column.name': 'Nombre del archivo',
  'decrypt.fileList.column.size': 'Tamaño',
  'decrypt.fileList.column.status': 'Estado',
  'decrypt.fileList.column.actions': 'Acciones',
  'decrypt.fileList.status.pending': 'Pendiente',
  'decrypt.fileList.status.decrypting': 'Descifrando',
  'decrypt.fileList.status.success': 'Completado',
  'decrypt.fileList.status.error': 'Error',
  'decrypt.fileList.action.info': 'Info',
  'decrypt.password.modal.title': 'Ingresa contraseña de descifrado',
  'decrypt.password.modal.placeholder': 'Ingresa contraseña',
  'decrypt.password.modal.hint': 'Ingresa la contraseña que estableciste durante el cifrado, solo se usará para el descifrado local',
  'decrypt.message.invalidFile': 'Por favor selecciona solo archivos .encrypted',
  'decrypt.message.duplicate': 'El archivo "{filename}" ya existe, se eliminó automáticamente el duplicado',
  'decrypt.message.oversizeTitle': 'Tamaño de archivo excedido',
  'decrypt.message.oversizeContent': 'Los siguientes archivos exceden el límite gratuito (4GB):',
  'decrypt.message.oversizeHint': 'Actualiza a VIP para descifrar archivos de cualquier tamaño',
  'decrypt.message.selectFile': 'Por favor selecciona archivos para descifrar',
  'decrypt.message.enterPassword': 'Por favor ingresa la contraseña de descifrado',
  'decrypt.message.decryptSuccess': 'El archivo {filename} ha sido guardado',
  'decrypt.message.saveCancel': 'Se canceló el guardado del archivo {filename}',
  'decrypt.message.downloadSuccess': 'El archivo {filename} se ha guardado en la carpeta de descargas',
  'decrypt.message.decryptError': 'Error al descifrar el archivo {filename}: {error}',
  'decrypt.message.batchError': 'Error en el descifrado por lotes, por favor inténtalo de nuevo',
  'sideMenu.storageInfo.title': 'Espacio de almacenamiento',
  'sideMenu.storageInfo.usage': 'Usado {used} / Total {total}',
  'sideMenu.storageStats.title': 'Estadísticas de almacenamiento',
  'sideMenu.storageStats.overview': 'Resumen',
  'sideMenu.storageStats.totalFiles': 'Total de archivos',
  'sideMenu.storageStats.totalSize': 'Tamaño total',
  'sideMenu.storageStats.fileTypes': 'Distribución de tipos de archivo',
  'sideMenu.storageStats.providers': 'Proveedores de servicio',
  'common.default': 'Predeterminado',
  'common.regionCode': 'Código de región',
  'common.nodeType': 'Tipo de nodo',
  'common.storageUsed': 'Espacio usado',
  'common.storageAvailable': 'Espacio disponible',
  'common.storageLimit': 'Capacidad total',
  'common.storageUsageDetail': 'Usado {used} / Total {total}',
  'common.defaultNode': 'Nodo predeterminado',
  'cloudDrive.nodeSelect.title': 'Seleccionar nodo de almacenamiento',
  'cloudDrive.nodeSelect.addNode': 'Agregar nodo de almacenamiento',
  'cloudDrive.nodeSelect.deleteConfirm.title': 'Confirmar eliminación del nodo',
  'cloudDrive.nodeSelect.deleteConfirm.content': '¿Está seguro de que desea eliminar el nodo "{nodeName}"? ¡Esta acción no se puede deshacer!',
  'cloudDrive.nodeSelect.deleteSuccess': 'Nodo eliminado exitosamente',
  'cloudDrive.nodeSelect.deleteFailed': 'Error al eliminar el nodo',
  
  // Creación de nodo
  'cloudDrive.nodeCreate.title': 'Agregar nodo de almacenamiento',
  'cloudDrive.nodeCreate.selectProvider': 'Seleccionar proveedor de nube',
  'cloudDrive.nodeCreate.nodeName': 'Nombre del nodo',
  'cloudDrive.nodeCreate.nodeNamePlaceholder': 'Dejar vacío para usar el nombre predeterminado',
  'cloudDrive.nodeCreate.nameMaxLength': 'El nombre del nodo no puede exceder los 50 caracteres',
  'cloudDrive.nodeCreate.noProviders': 'No hay proveedores de nube disponibles',
  'cloudDrive.nodeCreate.pingLatency': 'Latencia {value} ms',
  'cloudDrive.nodeCreate.pingTesting': 'Probando la latencia...',
  'cloudDrive.nodeCreate.pingFailed': 'Error al probar la latencia',
  'cloudDrive.nodeCreate.pingUnavailable': 'Latencia no disponible',
  'cloudDrive.nodeCreate.sortByLatency': 'Ordenar por latencia',
  'cloudDrive.nodeCreate.selectRegion': 'Seleccionar región',
  'cloudDrive.nodeCreate.selectedRegion': 'Región seleccionada',
  'cloudDrive.nodeCreate.noRegions': 'No hay regiones disponibles',
  'cloudDrive.nodeCreate.selectProviderPlaceholder': 'Seleccione un proveedor de nube',
  'cloudDrive.nodeCreate.selectProviderRequired': 'Por favor seleccione un proveedor de nube primero',
  'cloudDrive.nodeCreate.selectRegionRequired': 'Por favor seleccione una región primero',
  'cloudDrive.nodeCreate.loadProvidersFailed': 'Error al cargar la lista de proveedores de nube',
  'cloudDrive.nodeCreate.loadRegionsFailed': 'Error al cargar la lista de regiones',
  'cloudDrive.nodeCreate.nodeType': 'Tipo de nodo',
  'cloudDrive.nodeCreate.nodeType.standard': 'Almacenamiento estándar',
  'cloudDrive.nodeCreate.nodeType.lowFreq': 'Almacenamiento de baja frecuencia',
  'cloudDrive.nodeCreate.nodeType.archive': 'Almacenamiento de archivo',
  'cloudDrive.nodeCreate.storageLimit': 'Límite de almacenamiento',
  'cloudDrive.nodeCreate.storageLimitRequired': 'Por favor ingrese el límite de almacenamiento',
  'cloudDrive.nodeCreate.storageLimitMin': 'El límite de almacenamiento no puede ser menor a 1GB',
  'cloudDrive.nodeCreate.storageLimitPlaceholder': 'Ingrese el límite de almacenamiento (GB)',
  'cloudDrive.nodeCreate.success': 'Nodo de almacenamiento creado exitosamente',
  'cloudDrive.nodeCreate.failed': 'Error al crear el nodo de almacenamiento',
  
  // Edición de nodo
  'cloudDrive.nodeEdit.title': 'Editar nodo',
  'cloudDrive.nodeEdit.name': 'Nombre del nodo',
  'cloudDrive.nodeEdit.nameRequired': 'Por favor ingrese el nombre del nodo',
  'cloudDrive.nodeEdit.nameMaxLength': 'El nombre del nodo no puede exceder los 50 caracteres',
  
  // TextToImage page internationalization
  'create.prompt': 'Prompt',
  'create.prompt.placeholder': 'ej.: un gato cyberpunk caminando en el espacio, fondo de neón, alto detalle...',
  'create.prompt.required': 'Por favor ingrese un prompt',
  'create.prompt.generate': 'IA Generar Prompt',
  'create.prompt.enrich': 'IA Enriquecer Prompt',
  'create.prompt.generate.success': '¡Prompt generado con éxito!',
  'create.prompt.generate.error': 'Error al generar prompt, por favor intente de nuevo',
  'create.prompt.generate.empty': 'No se generó prompt, por favor intente de nuevo',
  'create.prompt.restore': 'Restaurar',
  'create.prompt.restore.success': 'Restaurado al prompt original',
  'create.prompt.restore.tooltip': 'Restaurar al prompt antes de la generación/enriquecimiento de IA',
  'create.negativePrompt': 'Prompt Negativo',
  'create.ratio': 'Relación de Aspecto',
  'create.style': 'Estilo Artístico',
  'create.batchSize': 'Tamaño del Lote',
  'create.generate': 'Generar Ahora',
  'create.negativePrompt.tooltip': 'Elementos que no desea en la imagen',
  'create.negativePrompt.placeholder': 'ej.: borroso, baja calidad, dedos deformados...',
  'create.generating': 'Generando...',
  'create.generating.waiting': 'La IA está creando, por favor espere...',
  'create.result.title': 'Resultados Generados',
  'create.downloadAll': 'Descargar Todo',
  'create.aspectRatio.1:1': '1:1 (Cuadrado)',
  'create.aspectRatio.16:9': '16:9 (Horizontal)',
  'create.aspectRatio.9:16': '9:16 (Vertical)',
  'create.aspectRatio.21:9': '21:9 (Cine)',
  'create.aspectRatio.4:3': '4:3 (Clásico)',
  'create.style.general': 'General',
  'create.style.anime': 'Anime',
  'create.style.realistic': 'Realista',
  'create.style.3d-render': '3D Render',
  'create.style.cyberpunk': 'Cyberpunk',
  'create.settings.loadFailed': 'Error al cargar la configuración del tipo de creación, mostrando todas las opciones',
  'create.settings.error': 'Error al cargar la configuración, mostrando todas las opciones',
  'create.noAvailableTabs': 'No hay tipos de creación disponibles',
  'create.network.error.title': 'Error de Conexión de Red',
  'create.network.error.description': 'No se puede cargar la configuración del tipo de creación. Por favor, verifique su conexión de red y actualice la página',
  'create.network.error.refresh': 'Actualizar Página',
  
  // TextToVideo page internationalization
  'create.prompt.video': 'Descripción de Escena de Video (Prompt)',
  'create.prompt.video.placeholder': 'ej., Un perro astronauta bailando en la superficie lunar, 8K, iluminación cinematográfica, surrealismo.',
  'create.prompt.video.required': 'Por favor ingrese una descripción de escena de video',
  'create.generate.video': 'Generar Video Ahora',
  'create.video.ratio': 'Relación de Aspecto del Video',
  'create.video.camera': 'Movimiento de Cámara',
  'create.video.duration': 'Duración del Video (segundos)',
  'create.video.format': 'Formato de Salida',
  'create.cameraMotion.none': 'Sin Movimiento (None)',
  'create.cameraMotion.zoomIn': 'Acercar (Zoom In)',
  'create.cameraMotion.dollyOut': 'Alejar (Dolly Out)',
  'create.cameraMotion.panLeft': 'Panorámica Izquierda (Pan Left)',
  'create.cameraMotion.tiltUp': 'Inclinación Arriba (Tilt Up)',
  'create.cameraMotion.orbital': '360° Orbital',
  'create.negativePrompt.video.placeholder': 'ej., marcas de agua, parpadeo, baja resolución, personajes borrosos...',
  'create.sora.thinking': 'Sora está pensando...',
  'create.video.analyzing': 'Analizando imagen y prompt, la IA está creando...',
  'create.video.info': 'Duración: {duration}s | Relación: {ratio}',
  'create.video.preview': 'Vista Previa del Video',
  'create.video.result': 'Vista Previa Final del Video',
  'create.video.empty': 'Los resultados generados se mostrarán aquí',
  'create.download': 'Descargar Video',
  'create.duration.format': '{duration}s',
  'create.duration.4s': '4s',
  'create.duration.8s': '8s',
  'create.duration.15s': '15s',
  'create.estimated.price': 'Estimado: {price}',
  'create.model.select': 'Seleccionar Modelo',
  'create.model.loading': 'Cargando modelos...',
  'create.model.loadFailed': 'Error al cargar la lista de modelos',
  'create.model.family.select': 'Seleccionar Familia de Modelos',
  'create.model.family.select.placeholder': 'Por favor seleccione una familia de modelos',
  'create.model.family.loadFailed': 'Error al cargar la lista de familias de modelos',
  'create.style.select.placeholder': 'Por favor seleccione un estilo artístico (opcional, por defecto usa el modelo de familia)',
  'create.model.style.loadFailed': 'Error al cargar la lista de modelos de estilo',
  'create.model.description': 'Descripción del Modelo',
  'create.model.aspectResolution': 'Resolución de Proporción',
  'create.model.fps': 'Velocidad de Fotogramas',
  'create.model.features': 'Características Soportadas',
  'create.model.feature.cameraMotion': 'Movimiento de Cámara',
  'create.model.feature.img2video': 'Imagen a Video',
  'create.model.feature.videoEdit': 'Edición de Video',
  'create.model.price.perSecond': '/seg',
  'create.model.detail': 'Detalles',
  'create.history.title': 'Historial de generación',
  'create.history.refresh': 'Actualizar',
  'create.history.empty': 'Sin historial de generación',
  'create.history.total': 'Total {total} registros',
  'create.history.status.queued': 'En cola',
  'create.history.status.processing': 'Procesando',
  'create.history.status.success': 'Éxito',
  'create.history.status.failed': 'Fallido',
  'create.history.status.timeout': 'Tiempo agotado',
  'create.history.failed.noImage': 'Generación fallida',
  'create.history.downloadAll.start': 'Iniciando descarga de {count} imágenes',
  'create.history.downloadAll.tooltip': 'Descargar todas las {count} imágenes',
  'create.history.download.tooltip': 'Descargar imagen',
  'create.history.detail.tooltip': 'Ver detalles',
  'create.history.noPrompt': 'Sin prompt',
  'create.history.deleteConfirm.title': 'Confirmar eliminación',
  'create.history.deleteConfirm.content': '¿Está seguro de que desea eliminar esta tarea? Esta acción no se puede deshacer.',
  'create.history.deleteSuccess': 'Eliminado con éxito',
  'create.history.deleteFailed': 'Error al eliminar',
  'create.taskDetail.title': 'Detalles de la tarea',
  'create.taskDetail.loading': 'Cargando...',
  'create.taskDetail.loadFailed': 'Error al cargar los detalles de la tarea',
  'create.taskDetail.noData': 'No hay datos disponibles',
  'create.taskDetail.basicInfo': 'Información básica',
  'create.taskDetail.model': 'Modelo',
  'create.taskDetail.taskType': 'Tipo de tarea',
  'create.taskDetail.createTime': 'Hora de creación',
  'create.taskDetail.duration': 'Duración de generación',
  'create.taskDetail.prompt': 'Prompt',
  'create.taskDetail.error': 'Mensaje de error',
  'create.taskDetail.outputFiles': 'Archivos de salida',
  'create.taskDetail.downloadAll': 'Descargar todo',
  'create.taskDetail.downloadAll.start': 'Iniciando descarga de {count} imágenes',
  'create.taskDetail.modelInfo': 'Información del modelo',
  'create.taskDetail.defaultResolution': 'Resolución predeterminada',
  'create.taskDetail.maxResolution': 'Resolución máxima',
  'create.taskDetail.aspectRatios': 'Proporciones soportadas',
  'create.taskDetail.formats': 'Formatos soportados',
  'create.taskDetail.prompt.copied': 'Prompt copiado',
  'create.taskDetail.liked': 'Me gusta',
  'create.taskDetail.like': 'Me gusta',
  'create.taskDetail.collected': 'Guardado',
  'create.taskDetail.collect': 'Guardar',
  'create.taskDetail.linkCopied': 'Enlace copiado',
  'create.taskDetail.share': 'Compartir',
  'create.taskDetail.outputs': 'Salidas',
  'create.taskDetail.preview': 'Vista previa',
  'create.taskDetail.download': 'Descargar',
  'create.taskDetail.generationFailed': 'Generación fallida',
  'create.taskDetail.generating': 'Generando...',
  'create.taskDetail.promptLabel': 'Prompt',
  'create.taskDetail.copy': 'Copiar',
  'create.taskDetail.executionStats': 'Estadísticas de ejecución',
  'create.taskDetail.creditsCost': 'Costo de créditos',
  'create.taskDetail.modelSpecs': 'Especificaciones del modelo',
  'create.taskDetail.capabilities': 'Capacidades',
  'create.taskDetail.supportedRatios': 'Proporciones soportadas',
  'create.taskDetail.dataError': 'Error de datos',
  'create.taskDetail.more': 'Más',
  'create.taskDetail.downloading': 'Descargando...',
  'create.taskDetail.points': 'pts',
  'create.taskDetail.seconds': 's',
  'create.taskDetail.status.success': 'ÉXITO',
  'create.taskDetail.status.failed': 'FALLIDO',
  'create.taskDetail.status.processing': 'PROCESANDO',
  'create.taskDetail.status.queued': 'EN COLA',
  'create.taskDetail.status.generating': 'GENERANDO',
  'create.taskDetail.durationLabel': 'Duración',
  'create.taskDetail.taskParams': 'Parámetros de la tarea',
  'create.taskDetail.aspectRatio': 'Relación de aspecto',
  'create.taskDetail.inputType': 'Tipo de entrada',
  'create.taskDetail.modelCode': 'Código del modelo',
  'create.taskDetail.regenerate': 'Regenerar',
  'create.taskDetail.feature.developing': 'Función en desarrollo',
  'create.taskDetail.result': 'Resultado de la generación',
  'create.taskDetail.copyPrompt': 'Copiar solicitud',
  'create.taskDetail.imageDimensions': 'Dimensiones',
  'create.taskDetail.fileSize': 'Tamaño del archivo',
  'create.taskDetail.loadingImageInfo': 'Cargando información de la imagen...',
  'create.history.failed.noVideo': 'Generación fallida',
  'create.video.generate.cancelled.polling': 'Sondeo de tarea cancelado',
  'create.video.generate.queued': 'Tarea de generación de video enviada, en cola...',
  'create.video.generate.noUrl': 'Generación de video completada, pero URL de video no encontrada',
  'create.video.status.checkFailed': 'Error al verificar el estado de la tarea',
  'create.video.generate.processing': 'Tarea de generación de video enviada, procesando...',
  'create.video.taskQueue': 'Cola de tareas',
  'create.video.polling': 'Generando video, por favor espere...',
  'create.video.ratio.invalid': 'Por favor seleccione una relación de aspecto de video soportada por el modelo',
  'create.waitingTask.queue': 'Cola de tareas',
  'create.waitingTask.empty': 'No hay tareas en progreso',
  'create.waitingTask.generating': 'Generando...',
  'create.waitingTask.queued': 'En cola',
  'create.waitingTask.cancel': 'Cancelar tarea',
  // HistorySection nueva internacionalización
  'create.history.copyPrompt': 'Copiar prompt',
  'create.history.download': 'Descargar',
  'create.history.delete': 'Eliminar',
  'create.history.generating': 'Generando...',
  'create.history.generationFailed': 'Generación fallida',
  'create.history.noPreview': 'Sin vista previa',
  // ImageToVideo nueva internacionalización
  'create.i2v.fileType.error': 'Por favor seleccione un archivo de imagen',
  'create.i2v.fileSize.error': 'El tamaño del archivo de imagen no puede exceder 10 MB',
  'create.i2v.imageSize.error': 'La altura de la imagen debe ser de al menos {minHeight}px, el tamaño actual de la imagen es {width}x{height}px',
  'create.i2v.fileRead.error': 'Error al leer la imagen',
  'create.i2v.replaceImage': 'Reemplazar imagen',
  'create.i2v.upload.supportedFormats': 'Soporta JPG, PNG, WebP, JFIF',
  'create.i2v.upload.required': 'Por favor suba una imagen de referencia',
  'create.i2v.upload': 'Subir Imagen de Referencia (Fotograma Inicial)',
  'create.i2v.upload.click': 'Haga clic o arrastre para subir',
  'create.i2v.prompt.required': 'Por favor ingrese una descripción de guía de movimiento',
  'create.i2v.uploading.image': 'Subiendo imagen a la nube...',
  'create.i2v.upload.success': 'Imagen subida exitosamente',
  'create.i2v.upload.failed': 'Error al subir la imagen, por favor intente nuevamente',
  'create.i2v.original': 'Original (fotograma inicial)',
  'create.i2v.result': 'Comparación de generación',
  'create.i2v.empty': 'La comparación de resultados generados y la imagen original se mostrará aquí',
  'create.generate.i2v': 'Comenzar generación de video',
  'create.prompt.i2v.placeholder': 'Ej: Hacer que la persona en la imagen comience a caminar, las hojas en el fondo se balancean con el viento...',
  'create.prompt.enhance.tooltip': 'Enriquecer el prompt con IA para hacer la descripción más detallada y vívida',
  'create.prompt.enhance': 'Enriquecer con IA',
  'create.prompt.enhance.empty': 'Por favor ingrese primero un prompt base',
  'create.prompt.enhance.success': '¡Prompt enriquecido exitosamente!',
  'create.prompt.enhance.empty.result': 'No se generó prompt enriquecido, por favor intente nuevamente',
  'create.prompt.enhance.error': 'Error al enriquecer el prompt, por favor intente nuevamente',
  'create.prompt.version.history': 'Historial de Versiones',
  'create.prompt.version.history.tooltip': 'Ver historial de versiones del prompt',
  // TaskDetailModal nueva internacionalización
  'create.taskDetail.unnamedTask': 'Tarea sin nombre',
  'create.taskDetail.prompt.title': 'Prompt',
  'create.taskDetail.tokenCost': 'Costo de tokens',
  'create.taskDetail.publish': 'Publicar en la comunidad',
  'create.taskDetail.selectCover': 'Seleccionar portada',
  'create.taskDetail.selectChannel': 'Seleccionar canal',
  'create.taskDetail.selectChallenge': 'Seleccionar desafío',
  'create.taskDetail.publishSuccess': 'Publicado con éxito',
  'create.taskDetail.loadChannelsFailed': 'Error al cargar canales',
  'create.taskDetail.loadChallengesFailed': 'Error al cargar desafíos',
  'create.taskDetail.publishFailed': 'Error al publicar',
  'create.taskDetail.daysLeft': 'Quedan {days} días',
  // ModelDetailModal nueva internacionalización
  'create.model.capability.t2v': 'T2V (Texto a Video)',
  'create.model.capability.img2video': 'Imagen a Video',
  'create.model.capability.videoEdit': 'Edición de Video',
  'create.model.capability.characterConsistency': 'Consistencia de Personajes',
  'create.model.capability.reference': 'Referencia',
  'create.model.capability.cameraMotion': 'Movimiento de Cámara',
  'create.model.aspectRatios': 'Relaciones de Aspecto',
  'create.model.resolution': 'Resolución',
  'create.model.resolution.default': 'Por defecto',
  'create.model.resolution.max': 'Máximo',
  'create.model.duration': 'Duración',
  'create.model.formats': 'Formatos',
  'create.model.like': 'Me gusta',
  'create.model.liked': 'Me gusta',
  'create.model.unliked': 'Ya no me gusta',
  'create.model.favorite': 'Favorito',
  'create.model.favorited': 'Agregado a favoritos',
  'create.model.unfavorited': 'Eliminado de favoritos',
  'create.model.share': 'Compartir',
  'create.model.linkCopied': 'Enlace copiado',
  'create.model.capabilities': 'Capacidades',
  'create.model.free': 'Gratis',
  'create.model.tokenCost.display': '{count} token',
  // Otras nuevas claves
  'create.aspectRatio.portrait': 'Vertical',
  'create.aspectRatio.landscape': 'Horizontal',
  'create.video.ratio.placeholder': 'Por favor seleccione la relación de aspecto del video',
  'create.video.format.placeholder': 'Por favor seleccione el formato de salida',
  'create.video.style': 'Estilo de Video',
  'create.video.style.tooltip': 'Seleccionar estilo de generación de video',
  'create.video.style.placeholder': 'Por favor seleccione el estilo de video',
  'create.video.quality': 'Calidad de Video',
  'create.video.quality.tooltip': 'Seleccionar calidad de generación de video',
  'create.video.quality.placeholder': 'Por favor seleccione la calidad de video',
  'create.duration.select.placeholder': 'Por favor seleccione la duración del video',
  'create.model.select.placeholder': 'Por favor seleccione primero un modelo',
  'video.not.supported': 'Su navegador no admite la reproducción de video.',
  // UnderDevelopment Internacionalización
  'underDevelopment.comingSoon': 'Próximamente',
  'underDevelopment.title': 'Función en desarrollo',
  'underDevelopment.subtitle': '¡Estamos trabajando duro para desarrollar esta función, manténgase atento!',
  'underDevelopment.backHome': 'Volver al inicio',
  'underDevelopment.goBack': 'Volver',
  // UserMenu Internacionalización
  'userMenu.email.notBound': 'Correo no vinculado',
  'userMenu.status.verified': 'Verificado',
  'userMenu.status.guest': 'Invitado',
  'userMenu.recharge': 'Recargar ahora',
  'userMenu.community': 'Comunidad',
  'userMenu.group.account': 'Configuración de cuenta',
  'userMenu.group.assets': 'Activos y pedidos',
  'userMenu.group.workspace': 'Espacio de trabajo',
  'userMenu.group.support': 'Soporte',
  'userMenu.item.profile': 'Perfil',
  'userMenu.item.settings': 'Configuración',
  'userMenu.item.security': 'Seguridad',
  'userMenu.item.privacy': 'Privacidad',
  'userMenu.item.wallet': 'Mi billetera',
  'userMenu.item.subscription': 'Suscripción',
  'userMenu.item.orders': 'Historial de pedidos',
  'userMenu.item.works': 'Mis obras',
  'userMenu.item.notifications': 'Notificaciones',
  'userMenu.item.help': 'Centro de ayuda',
  'userMenu.item.invite': 'Invitar amigos',
  'userMenu.item.feedback': 'Comentarios',
  'userMenu.item.about': 'Acerca de nosotros',
  'userMenu.level': 'Nivel',
  'userMenu.member.vip1': 'Miembro básico',
  'userMenu.member.vip2': 'Miembro plata',
  'userMenu.member.vip3': 'Miembro oro',
  'userMenu.member.vip4': 'Miembro diamante',
  'userMenu.member.vip5': 'Miembro definitivo',
  'userMenu.logout': 'Cerrar sesión',
  // Recharge Agreement Internacionalización
  'rechargeAgreement.back': 'Volver',
  'rechargeAgreement.title': 'Acuerdo de Servicio de Recarga',
  'rechargeAgreement.lastUpdated': 'Última actualización: ',
  'rechargeAgreement.goRecharge': 'Ir a Recargar',
  'rechargeAgreement.section1.title': 'I. Alcance del Acuerdo',
  'rechargeAgreement.section1.content1': 'Este acuerdo es un acuerdo legal entre usted y la plataforma con respecto a los servicios de recarga. Antes de usar el servicio de recarga, lea cuidadosamente todo el contenido de este acuerdo. Si no está de acuerdo con cualquier contenido de este acuerdo, o no puede entender con precisión el significado de los términos relevantes, no realice operaciones de recarga.',
  'rechargeAgreement.section1.content2': 'Al hacer clic en "Aceptar" o realizar operaciones de recarga, indica que ha leído, entendido y aceptado completamente todo el contenido de este acuerdo.',
  'rechargeAgreement.section2.title': 'II. Instrucciones de Recarga',
  'rechargeAgreement.section2.subtitle1': '2.1 Métodos de Recarga',
  'rechargeAgreement.section2.content1': 'La plataforma admite los siguientes métodos de recarga:',
  'rechargeAgreement.section2.method1': 'Alipay',
  'rechargeAgreement.section2.method2': 'WeChat Pay',
  'rechargeAgreement.section2.method3': 'Tarjeta Bancaria (UnionPay, Visa, MasterCard)',
  'rechargeAgreement.section2.method4': 'Criptomoneda USDT (ERC20/TRC20)',
  'rechargeAgreement.section2.subtitle2': '2.2 Moneda de Recarga',
  'rechargeAgreement.section2.content2': 'La plataforma admite la recarga en las siguientes monedas: CNY, USD, USDT. Puede haber conversión de tipo de cambio entre diferentes monedas, y el tipo de cambio específico está sujeto al tipo de cambio en tiempo real al momento de la recarga.',
  'rechargeAgreement.section2.subtitle3': '2.3 Límites de Recarga',
  'rechargeAgreement.section2.limit1': 'Recarga mínima única: 1 yuan (o equivalente en otras monedas)',
  'rechargeAgreement.section2.limit2': 'Recarga máxima única: 50,000 yuanes (o equivalente en otras monedas)',
  'rechargeAgreement.section2.limit3': 'Límite de recarga acumulada diaria: 100,000 yuanes (o equivalente en otras monedas)',
  'rechargeAgreement.section2.note': 'Nota: Los límites de recarga pueden variar según el método de pago, el nivel de cuenta y otros factores. Consulte la página de recarga para obtener detalles.',
  'rechargeAgreement.section3.title': 'III. Llegada de Recarga',
  'rechargeAgreement.section3.subtitle1': '3.1 Tiempo de Llegada',
  'rechargeAgreement.section3.time1': 'Alipay, WeChat Pay: Llegada en tiempo real',
  'rechargeAgreement.section3.time2': 'Tarjeta Bancaria: 1-3 días hábiles',
  'rechargeAgreement.section3.time3': 'USDT: Según el tiempo de confirmación de la cadena de bloques, generalmente 10-30 minutos',
  'rechargeAgreement.section3.subtitle2': '3.2 Manejo de Excepciones',
  'rechargeAgreement.section3.content1': 'Si la recarga no llega a tiempo, conserve el comprobante de pago y contacte al servicio al cliente de inmediato. La plataforma procesará su problema de recarga lo antes posible después de la verificación.',
  'rechargeAgreement.section4.title': 'IV. Política de Reembolso',
  'rechargeAgreement.section4.important': 'Importante: Después de una recarga exitosa, el saldo de la cuenta no admite reembolso directo. El saldo solo se puede usar para el consumo de servicios dentro de la plataforma.',
  'rechargeAgreement.section4.subtitle1': '4.1 Condiciones de Reembolso',
  'rechargeAgreement.section4.content1': 'Puede solicitar un reembolso en los siguientes casos:',
  'rechargeAgreement.section4.refund1': 'Recarga duplicada debido a fallas del sistema de la plataforma',
  'rechargeAgreement.section4.refund2': 'Servicio no disponible debido a razones de la plataforma, y el saldo de la cuenta no se ha consumido',
  'rechargeAgreement.section4.refund3': 'Otras circunstancias especiales aprobadas por la plataforma después de la revisión',
  'rechargeAgreement.section4.subtitle2': '4.2 Proceso de Reembolso',
  'rechargeAgreement.section4.process1': 'Enviar solicitud de reembolso y explicar el motivo',
  'rechargeAgreement.section4.process2': 'Revisión de la plataforma (generalmente 3-7 días hábiles)',
  'rechargeAgreement.section4.process3': 'Después de la aprobación, el reembolso se devolverá a su cuenta de pago',
  'rechargeAgreement.section5.title': 'V. Seguridad de la Cuenta',
  'rechargeAgreement.section5.content1': 'Usted es responsable de mantener adecuadamente la información de su cuenta y la contraseña. La plataforma no es responsable de las pérdidas causadas por el robo de cuenta o la fuga de contraseña debido a sus propias razones.',
  'rechargeAgreement.section5.content2': 'Si encuentra alguna anomalía en la cuenta, contacte al servicio al cliente de inmediato y cambie la contraseña. La plataforma lo ayudará a manejar problemas relacionados.',
  'rechargeAgreement.section6.title': 'VI. Descargo de Responsabilidad',
  'rechargeAgreement.section6.disclaimer1': 'La plataforma no es responsable de las interrupciones del servicio causadas por fuerza mayor (como desastres naturales, guerra, acciones gubernamentales, etc.)',
  'rechargeAgreement.section6.disclaimer2': 'Para problemas de recarga causados por fallas de plataformas de pago de terceros, la plataforma ayudará en el manejo pero no asume responsabilidad directa',
  'rechargeAgreement.section6.disclaimer3': 'Las pérdidas causadas por violaciones del usuario de este acuerdo o leyes y regulaciones relevantes serán asumidas por el usuario mismo',
  'rechargeAgreement.section7.title': 'VII. Modificación del Acuerdo',
  'rechargeAgreement.section7.content1': 'La plataforma tiene el derecho de modificar este acuerdo según las necesidades de desarrollo comercial. Después de la modificación del acuerdo, se anunciará en un lugar prominente en la plataforma. Si continúa usando el servicio de recarga, se considera que acepta el acuerdo modificado.',
  'rechargeAgreement.section8.title': 'VIII. Información de Contacto',
  'rechargeAgreement.section8.content1': 'Si tiene alguna pregunta sobre este acuerdo, o necesita solicitar un reembolso o manejar problemas de recarga, contáctenos a través de los siguientes métodos:',
  'rechargeAgreement.section8.contact1': 'Correo de Servicio al Cliente: support@example.com',
  'rechargeAgreement.section8.contact2': 'Servicio al Cliente en Línea: Días laborables 9:00-18:00',
  'rechargeAgreement.section8.contact3': 'Centro de Ayuda: Ver Preguntas Frecuentes',
  // Internacionalización de perfil
  'profile.editProfile': 'Editar Perfil',
  'profile.creditScore': 'Puntuación de Crédito',
  'profile.level': 'Nivel',
  'profile.balance': 'Saldo',
  'profile.tab.basic': 'Información Básica',
  'profile.tab.account': 'Activos de Cuenta',
  'profile.section.personal': 'Información Personal',
  'profile.section.contact': 'Contacto',
  'profile.section.wallet': 'Billetera USDT',
  'profile.label.username': 'Nombre de Usuario',
  'profile.label.realName': 'Nombre Real',
  'profile.label.accountStatus': 'Estado de Cuenta',
  'profile.label.phone': 'Número de Teléfono',
  'profile.label.email': 'Correo Electrónico',
  'profile.label.registerTime': 'Hora de Registro',
  'profile.label.availableBalance': 'Saldo Disponible',
  'profile.label.frozenAmount': 'Cantidad Congelada',
  'profile.value.notVerified': 'No Verificado',
  'profile.value.notBound': 'No Vinculado',
  'profile.value.noAddress': 'Sin Dirección TRC20',
  'profile.value.noDescription': 'Esta persona es perezosa y no ha escrito nada',
  'profile.status.normal': 'Normal',
  'profile.status.disabled': 'Deshabilitado',
  'profile.tooltip.verified': 'Verificado',
  'profile.tooltip.unverified': 'Verificar Ahora',
  'profile.banner.construction': 'Esta página está en construcción...',
  'profile.modal.title': 'Editar Perfil',
  'profile.modal.cancel': 'Cancelar',
  'profile.modal.save': 'Guardar Cambios',
  'profile.modal.avatarSection': 'Configuración de Avatar',
  'profile.modal.basicSection': 'Información Básica',
  'profile.modal.contactSection': 'Información de Contacto',
  'profile.modal.changeAvatar': 'Cambiar Avatar',
  'profile.modal.avatarHint': 'Soporta formatos JPG, PNG, máximo 2MB',
  'profile.modal.nickname': 'Apodo',
  'profile.modal.nicknamePlaceholder': 'Ingrese su apodo',
  'profile.modal.description': 'Biografía',
  'profile.modal.descriptionPlaceholder': 'Preséntate en una oración...',
  'profile.modal.phone': 'Teléfono',
  'profile.modal.email': 'Correo',
  'profile.message.avatarSizeLimit': 'El tamaño de la imagen no puede exceder 2MB',
  'profile.message.avatarUploadSuccess': 'Avatar subido exitosamente',
  'profile.message.saveSuccess': 'Guardado exitosamente',
  'profile.message.saveFailed': 'Error al guardar',
  'profile.message.uploadAvatarFailed': 'Error al subir avatar',
  'profile.message.operationFailed': 'Operación fallida',
  'privacyPreferences.title': 'Preferencias de Privacidad',
  'privacyPreferences.description': 'Administre su configuración de privacidad y controle cómo recopilamos y usamos sus datos',
  'privacyPreferences.back': 'Atrás',
  'privacyPreferences.save': 'Guardar Configuración',
  'privacyPreferences.saveSuccess': 'Preferencias de privacidad guardadas exitosamente',
  'privacyPreferences.saveError': 'Error al guardar, por favor intente más tarde',
  'privacyPreferences.required': 'Requerido',
  'privacyPreferences.info': 'Sus preferencias de privacidad se guardarán localmente y se aplicarán automáticamente en su próxima visita. Inicie sesión para sincronizar la configuración con la nube.',
  'privacyPreferences.info.loggedIn': 'Sus preferencias de privacidad se guardarán en su cuenta y se sincronizarán en todos sus dispositivos. Puede regresar a esta página para modificar esta configuración en cualquier momento.',
  'cookieBanner.message': 'Usamos cookies y almacenamiento local para inicio de sesión, tema y funciones básicas. Al continuar acepta nuestra política de privacidad.',
  'cookieBanner.acceptAll': 'Aceptar todo',
  'cookieBanner.essentialOnly': 'Solo esenciales',
  'cookieBanner.settings': 'Preferencias',
  'privacyPreferences.cookies.title': 'Preferencias de Cookies',
  'privacyPreferences.cookies.description': 'Las cookies nos ayudan a proporcionar una mejor experiencia de servicio. Puede elegir aceptar o rechazar ciertos tipos de cookies.',
  'privacyPreferences.cookies.essential': 'Cookies Esenciales',
  'privacyPreferences.cookies.essential.desc': 'Estas cookies son necesarias para que el sitio web funcione correctamente y no se pueden desactivar. Generalmente se usan para seguridad, inicio de sesión y funcionalidad básica.',
  'privacyPreferences.cookies.functional': 'Cookies Funcionales',
  'privacyPreferences.cookies.functional.desc': 'Estas cookies permiten que el sitio web recuerde sus elecciones y proporcione funcionalidad mejorada y experiencia personalizada.',
  'privacyPreferences.cookies.analytics': 'Cookies de Análisis',
  'privacyPreferences.cookies.analytics.desc': 'Estas cookies nos ayudan a entender cómo los visitantes usan el sitio web para que podamos mejorar nuestros servicios.',
  'privacyPreferences.cookies.marketing': 'Cookies de Marketing',
  'privacyPreferences.cookies.marketing.desc': 'Estas cookies se usan para rastrear su actividad de navegación para mostrarle anuncios y contenido relevantes.',
  'privacyPreferences.data.title': 'Preferencias de Recopilación de Datos',
  'privacyPreferences.data.description': 'Controle cómo recopilamos y usamos sus datos para mejorar la experiencia del servicio.',
  'privacyPreferences.data.collection': 'Recopilación de Datos',
  'privacyPreferences.data.collection.desc': 'Permítanos recopilar los datos de uso necesarios para proporcionar y mejorar los servicios.',
  'privacyPreferences.data.analytics': 'Análisis de Datos',
  'privacyPreferences.data.analytics.desc': 'Permítanos analizar sus patrones de uso para optimizar el rendimiento del servicio y la experiencia del usuario.',
  'privacyPreferences.data.personalization': 'Personalización',
  'privacyPreferences.data.personalization.desc': 'Permítanos proporcionar contenido y recomendaciones personalizados basados en sus preferencias y hábitos de uso.',
  'privacyPreferences.marketing.title': 'Preferencias de Marketing',
  'privacyPreferences.marketing.description': 'Elija los tipos de comunicaciones de marketing que desea recibir.',
  'privacyPreferences.marketing.emails': 'Correos de Marketing',
  'privacyPreferences.marketing.emails.desc': 'Reciba notificaciones por correo electrónico sobre actualizaciones de productos, promociones y ofertas especiales.',
  'privacyPreferences.marketing.sms': 'SMS de Marketing',
  'privacyPreferences.marketing.sms.desc': 'Reciba notificaciones SMS sobre actualizaciones importantes y promociones.',
  'privacyPreferences.marketing.push': 'Notificaciones Push',
  'privacyPreferences.marketing.push.desc': 'Reciba notificaciones push del navegador, incluidas actualizaciones de productos y mensajes importantes.',
  'privacyPreferences.thirdParty.title': 'Compartir Datos con Terceros',
  'privacyPreferences.thirdParty.description': 'Controle si permite compartir sus datos con proveedores de servicios de terceros.',
  'privacyPreferences.thirdParty.sharing': 'Compartir Datos con Terceros',
  'privacyPreferences.thirdParty.sharing.desc': 'Permítanos compartir datos de uso anonimizados con proveedores de servicios de terceros de confianza para mejorar los servicios.',
  
  // Política de Privacidad
  'privacyPolicy.title': 'Política de Privacidad',
  'privacyPolicy.lastUpdated': 'Última actualización: {date}',
  'privacyPolicy.intro1': 'Esta Política de Privacidad describe cómo la plataforma AIMATEX (en adelante "nosotros" o "esta plataforma") recopila, usa, almacena y protege su información personal cuando utiliza nuestros servicios, así como sus derechos de privacidad. Valoramos mucho la protección de su privacidad. Por favor, lea atentamente esta Política de Privacidad.',
  'privacyPolicy.intro2': 'Al usar nuestros servicios, usted acepta esta Política de Privacidad. Si no está de acuerdo con alguna parte de esta Política de Privacidad, por favor no utilice nuestros servicios.',
  'privacyPolicy.section1.title': 'I. Información que Recopilamos',
  'privacyPolicy.section1.1.title': '1.1 Información que Usted Proporciona',
  'privacyPolicy.section1.1.intro': 'Al usar este servicio, es posible que necesite proporcionar la siguiente información:',
  'privacyPolicy.section1.1.item1.label': 'Información de Cuenta',
  'privacyPolicy.section1.1.item1.desc': 'Nombre de usuario, dirección de correo electrónico, contraseña, número de teléfono, etc.',
  'privacyPolicy.section1.1.item2.label': 'Información de Perfil',
  'privacyPolicy.section1.1.item2.desc': 'Avatar, apodo, biografía, etc. (opcional)',
  'privacyPolicy.section1.1.item3.label': 'Información de Pago',
  'privacyPolicy.section1.1.item3.desc': 'Métodos de pago, dirección de facturación, etc. (para procesar pagos)',
  'privacyPolicy.section1.1.item4.label': 'Contenido Generado',
  'privacyPolicy.section1.1.item4.desc': 'Indicaciones de texto, imágenes de referencia, videos, música, imágenes, modelos 3D generados, etc. que usted carga',
  'privacyPolicy.section1.2.title': '1.2 Información Recopilada Automáticamente',
  'privacyPolicy.section1.2.intro': 'Cuando utiliza este servicio, podemos recopilar automáticamente la siguiente información:',
  'privacyPolicy.section1.2.item1.label': 'Información del Dispositivo',
  'privacyPolicy.section1.2.item1.desc': 'Tipo de dispositivo, sistema operativo, tipo y versión del navegador, identificadores de dispositivo, etc.',
  'privacyPolicy.section1.2.item2.label': 'Datos de Uso',
  'privacyPolicy.section1.2.item2.desc': 'Hora de acceso, páginas visitadas, funciones utilizadas, registros de operaciones, etc.',
  'privacyPolicy.section1.2.item3.label': 'Información de Red',
  'privacyPolicy.section1.2.item3.desc': 'Dirección IP, tipo de red, operador de red, etc.',
  'privacyPolicy.section1.2.item4.label': 'Información de Registro',
  'privacyPolicy.section1.2.item4.desc': 'Registros de errores, datos de rendimiento, etc.',
  'privacyPolicy.section1.3.title': '1.3 Cookies y Tecnologías Similares',
  'privacyPolicy.section1.3.intro': 'Utilizamos cookies y tecnologías similares para:',
  'privacyPolicy.section1.3.item1': 'Mantener su estado de inicio de sesión',
  'privacyPolicy.section1.3.item2': 'Recordar sus preferencias (como idioma, tema, etc.)',
  'privacyPolicy.section1.3.item3': 'Analizar el uso del servicio para mejorar la calidad del servicio',
  'privacyPolicy.section1.3.item4': 'Proporcionar una experiencia personalizada',
  'privacyPolicy.section1.3.note': 'Puede rechazar las cookies a través de la configuración del navegador, pero esto puede afectar el uso de algunas funciones.',
  'privacyPolicy.section2.title': 'II. Propósito del Uso de la Información',
  'privacyPolicy.section2.intro': 'Recopilamos y utilizamos su información para los siguientes propósitos:',
  'privacyPolicy.section2.item1.label': 'Proporcionar Servicios',
  'privacyPolicy.section2.item1.desc': 'Procesar sus solicitudes de generación de contenidos (videos, música, imágenes, modelos 3D, etc.), gestionar su cuenta y obras, etc.',
  'privacyPolicy.section2.item2.label': 'Mejorar Servicios',
  'privacyPolicy.section2.item2.desc': 'Analizar el uso, optimizar el rendimiento del servicio y la experiencia del usuario',
  'privacyPolicy.section2.item3.label': 'Gestión de Cuenta',
  'privacyPolicy.section2.item3.desc': 'Verificar identidad, procesar pagos, enviar notificaciones, etc.',
  'privacyPolicy.section2.item4.label': 'Seguridad',
  'privacyPolicy.section2.item4.desc': 'Detectar y prevenir fraudes, abusos, amenazas de seguridad, etc.',
  'privacyPolicy.section2.item5.label': 'Soporte al Cliente',
  'privacyPolicy.section2.item5.desc': 'Responder a sus consultas, procesar quejas y comentarios, etc.',
  'privacyPolicy.section2.item6.label': 'Cumplimiento Legal',
  'privacyPolicy.section2.item6.desc': 'Cumplir con los requisitos legales, cooperar con investigaciones de las fuerzas del orden, etc.',
  'privacyPolicy.section3.title': 'III. Compartir y Divulgar Información',
  'privacyPolicy.section3.1.title': '3.1 No Vendemos Su Información Personal',
  'privacyPolicy.section3.1.content': 'No vendemos, alquilamos ni comerciamos su información personal con terceros.',
  'privacyPolicy.section3.2.title': '3.2 Proveedores de Servicios',
  'privacyPolicy.section3.2.intro': 'Podemos compartir información con los siguientes tipos de proveedores de servicios:',
  'privacyPolicy.section3.2.item1.label': 'Proveedores de Servicios en la Nube',
  'privacyPolicy.section3.2.item1.desc': 'Para almacenamiento y procesamiento de datos',
  'privacyPolicy.section3.2.item2.label': 'Proveedores de Servicios de Pago',
  'privacyPolicy.section3.2.item2.desc': 'Para procesar transacciones de pago',
  'privacyPolicy.section3.2.item3.label': 'Proveedores de Servicios de Análisis',
  'privacyPolicy.section3.2.item3.desc': 'Para analizar el uso del servicio',
  'privacyPolicy.section3.2.item4.label': 'Proveedores de Servicios de Soporte al Cliente',
  'privacyPolicy.section3.2.item4.desc': 'Para proporcionar soporte al cliente',
  'privacyPolicy.section3.2.note': 'Estos proveedores de servicios solo pueden usar la información para brindarnos servicios y no para otros propósitos.',
  'privacyPolicy.section3.3.title': '3.3 Requisitos Legales',
  'privacyPolicy.section3.3.intro': 'Podemos divulgar su información en las siguientes circunstancias:',
  'privacyPolicy.section3.3.item1': 'Cumplir con leyes, regulaciones, órdenes judiciales o requisitos gubernamentales',
  'privacyPolicy.section3.3.item2': 'Proteger nuestros derechos, propiedad o seguridad',
  'privacyPolicy.section3.3.item3': 'Prevenir o investigar posibles actividades ilegales',
  'privacyPolicy.section3.3.item4': 'Proteger la seguridad de los usuarios o del público',
  'privacyPolicy.section3.4.title': '3.4 Transferencia de Negocio',
  'privacyPolicy.section3.4.content': 'Si ocurre una fusión, adquisición o transferencia de activos, su información puede ser transferida. Le notificaremos antes de la transferencia.',
  'privacyPolicy.section4.title': 'IV. Almacenamiento y Seguridad de la Información',
  'privacyPolicy.section4.1.title': '4.1 Ubicación de Almacenamiento',
  'privacyPolicy.section4.1.content': 'Su información puede almacenarse en servidores ubicados dentro o fuera de la República Popular China. Tomaremos medidas apropiadas para asegurar la seguridad de la información.',
  'privacyPolicy.section4.2.title': '4.2 Período de Almacenamiento',
  'privacyPolicy.section4.2.intro': 'Solo conservamos su información durante el período necesario:',
  'privacyPolicy.section4.2.item1': 'Información de cuenta: durante la duración de su cuenta y durante un período después de la cancelación',
  'privacyPolicy.section4.2.item2': 'Contenido generado: conservado según sus configuraciones o requisitos legales',
  'privacyPolicy.section4.2.item3': 'Datos de uso: generalmente conservados por un período más corto para análisis y mejora del servicio',
  'privacyPolicy.section4.3.title': '4.3 Medidas de Seguridad',
  'privacyPolicy.section4.3.intro': 'Tomamos las siguientes medidas de seguridad para proteger su información:',
  'privacyPolicy.section4.3.item1': 'Transmisión y almacenamiento cifrados',
  'privacyPolicy.section4.3.item2': 'Control de acceso y autenticación',
  'privacyPolicy.section4.3.item3': 'Auditorías de seguridad regulares y escaneos de vulnerabilidades',
  'privacyPolicy.section4.3.item4': 'Capacitación de empleados y acuerdos de confidencialidad',
  'privacyPolicy.section4.3.note': 'Tenga en cuenta que ninguna medida de seguridad es 100% segura. No podemos garantizar la seguridad absoluta de la información.',
  'privacyPolicy.section5.title': 'V. Sus Derechos',
  'privacyPolicy.section5.intro': 'De acuerdo con las leyes y regulaciones aplicables, usted tiene los siguientes derechos:',
  'privacyPolicy.section5.item1.label': 'Derecho de Acceso',
  'privacyPolicy.section5.item1.desc': 'Ver su información personal que tenemos',
  'privacyPolicy.section5.item2.label': 'Derecho de Rectificación',
  'privacyPolicy.section5.item2.desc': 'Corregir información inexacta o incompleta',
  'privacyPolicy.section5.item3.label': 'Derecho de Eliminación',
  'privacyPolicy.section5.item3.desc': 'Solicitar la eliminación de su información personal (excepto cuando la ley requiera su conservación)',
  'privacyPolicy.section5.item4.label': 'Derecho a Retirar el Consentimiento',
  'privacyPolicy.section5.item4.desc': 'Retirar su consentimiento para el procesamiento de información',
  'privacyPolicy.section5.item5.label': 'Derecho a la Portabilidad de Datos',
  'privacyPolicy.section5.item5.desc': 'Obtener una copia de su información personal',
  'privacyPolicy.section5.item6.label': 'Derecho de Oposición',
  'privacyPolicy.section5.item6.desc': 'Oponerse a ciertas actividades de procesamiento de información',
  'privacyPolicy.section5.note': 'Para ejercer los derechos anteriores, contáctenos a través de la información de contacto al final de esta Política de Privacidad.',
  'privacyPolicy.section6.title': 'VI. Protección de Menores',
  'privacyPolicy.section6.content1': 'Este servicio está dirigido principalmente a usuarios mayores de 18 años. Si tiene menos de 18 años, utilice este servicio con el consentimiento y bajo la supervisión de su tutor.',
  'privacyPolicy.section6.content2': 'Si descubrimos que hemos recopilado información personal de usuarios menores de 18 años sin el consentimiento del tutor, eliminaremos la información relevante lo antes posible.',
  'privacyPolicy.section7.title': 'VII. Enlaces de Terceros',
  'privacyPolicy.section7.content': 'Este servicio puede contener enlaces a sitios web de terceros. No somos responsables de las prácticas de privacidad de estos sitios web de terceros. Al visitar estos sitios, revise sus políticas de privacidad.',
  'privacyPolicy.section8.title': 'VIII. Cambios en la Política de Privacidad',
  'privacyPolicy.section8.content1': 'Podemos actualizar esta Política de Privacidad de vez en cuando. Los cambios importantes se le notificarán al menos 30 días antes de que entren en vigor. El uso continuado del servicio indica su aceptación de la Política de Privacidad actualizada.',
  'privacyPolicy.section8.content2': 'Actualizaremos la fecha de "Última actualización" en la parte superior de esta página y le informaremos sobre cambios importantes por correo electrónico o notificaciones en la aplicación.',
  'privacyPolicy.section9.title': 'IX. Contáctenos',
  'privacyPolicy.section9.intro': 'Si tiene preguntas, comentarios o quejas sobre esta Política de Privacidad, contáctenos a través de los siguientes métodos:',
  'privacyPolicy.section9.email': 'Correo electrónico: {email}',
  'privacyPolicy.section9.hours': 'Horario de atención al cliente: días laborables 9:00-18:00',
  'privacyPolicy.section9.response': 'Responderemos a su solicitud dentro de un tiempo razonable.',
  
  // Términos de Servicio
  'termsOfService.title': 'Términos de Servicio',
  'termsOfService.lastUpdated': 'Última actualización: {date}',
  'termsOfService.intro': 'Antes de usar nuestros servicios, lea atentamente estos Términos de Servicio. Al acceder o usar la plataforma AIMATEX (en adelante "esta plataforma" o "servicio"), usted acepta estar sujeto a estos Términos de Servicio. Si no está de acuerdo con alguna parte de estos Términos de Servicio, por favor no utilice nuestros servicios.',
  'termsOfService.section1.title': 'I. Definiciones e Interpretación',
  'termsOfService.section1.1.title': '1.1 Definiciones',
  'termsOfService.section1.1.intro': 'En estos Términos de Servicio, a menos que el contexto indique lo contrario, los siguientes términos tienen los siguientes significados:',
  'termsOfService.section1.1.item1.label': '"Plataforma" o "Esta Plataforma"',
  'termsOfService.section1.1.item1.desc': 'Se refiere a la plataforma de servicio de generación de videos AIMATEX, incluyendo pero no limitado a sitios web, aplicaciones móviles y servicios relacionados.',
  'termsOfService.section1.1.item2.label': '"Nosotros", "Nuestro", "Empresa"',
  'termsOfService.section1.1.item2.desc': 'Se refiere al operador de la plataforma AIMATEX, es decir, ProTX Team.',
  'termsOfService.section1.1.item3.label': '"Usted", "Usuario"',
  'termsOfService.section1.1.item3.desc': 'Se refiere a cualquier individuo, empresa u otra entidad legal que accede o usa este servicio.',
  'termsOfService.section1.1.item4.label': '"Servicio"',
  'termsOfService.section1.1.item4.desc': 'Se refiere a todas las funciones y servicios proporcionados por esta plataforma, incluyendo pero no limitado a generación de videos, música, imágenes, modelos 3D IA y otros contenidos, selección de modelos, gestión de obras, gestión de cuentas de usuario, etc.',
  'termsOfService.section1.1.item5.label': '"Contenido"',
  'termsOfService.section1.1.item5.desc': 'Se refiere a cualquier texto, imagen, video, audio y otros materiales cargados, generados, creados o compartidos por usuarios a través de esta plataforma.',
  'termsOfService.section1.1.item6.label': '"Contenido Generado"',
  'termsOfService.section1.1.item6.desc': 'Se refiere a videos, música, imágenes, modelos 3D y otras obras generadas por usuarios usando los modelos IA de esta plataforma.',
  'termsOfService.section1.1.item7.label': '"Cuenta"',
  'termsOfService.section1.1.item7.desc': 'Se refiere a la cuenta de usuario registrada por usuarios en esta plataforma.',
  'termsOfService.section2.title': 'II. Descripción del Servicio',
  'termsOfService.section2.1.title': '2.1 Contenido del Servicio',
  'termsOfService.section2.1.intro': 'Esta plataforma proporciona servicios integrales de generación de contenidos IA, incluyendo pero no limitado a:',
  'termsOfService.section2.1.item1': 'Generación de texto a medios (videos, música, imágenes, modelos 3D, etc.) (Text-to-Media)',
  'termsOfService.section2.1.item2': 'Generación de imagen a medios (videos, modelos 3D, etc.) (Image-to-Media)',
  'termsOfService.section2.1.item3': 'Gestión y visualización de diversas obras generadas',
  'termsOfService.section2.1.item4': 'Selección y gestión de modelos',
  'termsOfService.section2.1.item5': 'Cuentas de usuario y centro personal',
  'termsOfService.section2.1.item6': 'Servicios de suscripción y pago',
  'termsOfService.section2.2.title': '2.2 Cambios en el Servicio',
  'termsOfService.section2.2.content': 'Nos reservamos el derecho de modificar, suspender o terminar parte o todo el servicio en cualquier momento sin previo aviso. No somos responsables de ninguna pérdida causada por cambios en el servicio.',
  'termsOfService.section3.title': 'III. Cuentas de Usuario',
  'termsOfService.section3.1.title': '3.1 Registro de Cuenta',
  'termsOfService.section3.1.intro': 'El uso de este servicio requiere registro de cuenta. Al registrarse, usted acepta:',
  'termsOfService.section3.1.item1': 'Proporcionar información de registro verdadera, precisa y completa',
  'termsOfService.section3.1.item2': 'Actualizar la información de registro de manera oportuna para mantenerla verdadera, precisa y completa',
  'termsOfService.section3.1.item3': 'Ser responsable de todas las actividades bajo su cuenta',
  'termsOfService.section3.1.item4': 'Mantener su contraseña de cuenta segura y no transferir, vender o prestar su cuenta a otros',
  'termsOfService.section3.2.title': '3.2 Restricción de Edad',
  'termsOfService.section3.2.content': 'Debe tener al menos 18 años para usar este servicio. Si tiene menos de 18 años, utilice este servicio con el consentimiento y bajo la supervisión de su tutor.',
  'termsOfService.section3.3.title': '3.3 Seguridad de la Cuenta',
  'termsOfService.section3.3.content': 'Usted es responsable de mantener la seguridad de su cuenta. Si descubre que su cuenta ha sido comprometida o existe una vulnerabilidad de seguridad, notifíquenos inmediatamente. No somos responsables de las pérdidas causadas por su fallo en proteger adecuadamente la información de su cuenta.',
  'termsOfService.section4.title': 'IV. Reglas de Uso',
  'termsOfService.section4.1.title': '4.1 Actividades Prohibidas',
  'termsOfService.section4.1.intro': 'Al usar este servicio, no debe:',
  'termsOfService.section4.1.item1': 'Generar, cargar o compartir contenido ilegal, dañino, amenazante, abusivo, acosador, difamatorio, vulgar, obsceno, que invada la privacidad o los derechos de propiedad intelectual de otros',
  'termsOfService.section4.1.item2': 'Generar o difundir información falsa, contenido engañoso o malicioso',
  'termsOfService.section4.1.item3': 'Usar este servicio para fraude comercial, lavado de dinero u otras actividades ilegales',
  'termsOfService.section4.1.item4': 'Interferir o destruir el funcionamiento normal de esta plataforma, incluyendo pero no limitado al uso de herramientas automatizadas, rastreadores, virus, etc.',
  'termsOfService.section4.1.item5': 'Acceder sin autorización a cualquier sistema, datos o cuenta de esta plataforma',
  'termsOfService.section4.1.item6': 'Copiar, modificar, distribuir, vender o alquilar cualquier parte de esta plataforma',
  'termsOfService.section4.1.item7': 'Hacer ingeniería inversa, descompilar o desensamblar cualquier software de esta plataforma',
  'termsOfService.section4.2.title': '4.2 Responsabilidad del Contenido',
  'termsOfService.section4.2.content': 'Usted es totalmente responsable de todo el contenido generado, cargado o compartido a través de esta plataforma. No pre-revisamos el contenido generado por usuarios, pero nos reservamos el derecho de eliminar contenido que viole las reglas en cualquier momento.',
  'termsOfService.section5.title': 'V. Propiedad Intelectual',
  'termsOfService.section5.1.title': '5.1 Propiedad Intelectual de la Plataforma',
  'termsOfService.section5.1.content': 'Todos los derechos de propiedad intelectual de esta plataforma, incluyendo pero no limitado a marcas, patentes, derechos de autor, secretos comerciales, etc., pertenecen a nosotros o a los titulares de derechos correspondientes. No puede usarlos sin autorización.',
  'termsOfService.section5.2.title': '5.2 Contenido Generado por Usuario',
  'termsOfService.section5.2.content': 'Los derechos de propiedad intelectual del contenido que genera a través de esta plataforma le pertenecen. Sin embargo, nos otorga un derecho no exclusivo, mundial, gratuito y sublicenciable para usar, mostrar y distribuir su contenido para proporcionar y mejorar servicios.',
  'termsOfService.section5.3.title': '5.3 Modelos IA',
  'termsOfService.section5.3.content': 'Los derechos de propiedad intelectual de los modelos IA (incluyendo modelos Sora) utilizados por esta plataforma pertenecen a sus desarrolladores. No puede copiar, modificar o distribuir estos modelos.',
  'termsOfService.section6.title': 'VI. Servicios de Pago',
  'termsOfService.section6.1.title': '6.1 Modelos de Pago',
  'termsOfService.section6.1.content': 'Esta plataforma ofrece dos modelos de pago: suscripción y pago por uso. Los precios específicos y los métodos de facturación están sujetos a los anuncios de la plataforma.',
  'termsOfService.section6.2.title': '6.2 Pago',
  'termsOfService.section6.2.content': 'Usted acepta pagar las tarifas del servicio según los precios anunciados por la plataforma. Todas las tarifas se calculan en RMB u otras monedas soportadas por la plataforma. Después de un pago exitoso, las tarifas no son reembolsables, a menos que la ley disponga lo contrario o hayamos hecho otros compromisos.',
  'termsOfService.section6.3.title': '6.3 Política de Reembolso',
  'termsOfService.section6.3.content': 'A menos que la ley disponga lo contrario o hayamos hecho otros compromisos, las tarifas pagadas no son reembolsables. Si el servicio no se puede usar normalmente debido a problemas de la plataforma, proporcionaremos reembolsos o compensaciones según la situación real.',
  'termsOfService.section7.title': 'VII. Disponibilidad del Servicio',
  'termsOfService.section7.1.title': '7.1 Interrupción del Servicio',
  'termsOfService.section7.1.intro': 'No somos responsables de las interrupciones del servicio causadas por las siguientes razones:',
  'termsOfService.section7.1.item1': 'Mantenimiento, actualización o falla del sistema',
  'termsOfService.section7.1.item2': 'Factores de fuerza mayor (como desastres naturales, guerras, huelgas, etc.)',
  'termsOfService.section7.1.item3': 'Problemas con proveedores de servicios de terceros',
  'termsOfService.section7.1.item4': 'Fallas de red o problemas de dispositivos de usuario',
  'termsOfService.section7.2.title': '7.2 Garantía del Servicio',
  'termsOfService.section7.2.content': 'Nos esforzamos por asegurar la estabilidad y disponibilidad del servicio, pero no garantizamos que el servicio no será interrumpido, sin errores o completamente seguro. El servicio se proporciona "tal cual" y "según disponibilidad" sin garantías expresas o implícitas.',
  'termsOfService.section8.title': 'VIII. Protección de Privacidad',
  'termsOfService.section8.content': 'Valoramos la protección de su privacidad. Para obtener información sobre cómo recopilamos, usamos y protegemos su información personal, consulte nuestra Política de Privacidad. El uso de este servicio indica su acuerdo con nuestra Política de Privacidad.',
  'termsOfService.section9.title': 'IX. Limitación de Responsabilidad',
  'termsOfService.section9.1.title': '9.1 Alcance de la Responsabilidad',
  'termsOfService.section9.1.intro': 'En la medida máxima permitida por la ley, no somos responsables de ningún daño directo, indirecto, incidental, especial o consecuente resultante del uso o la imposibilidad de usar este servicio, incluyendo pero no limitado a:',
  'termsOfService.section9.1.item1': 'Pérdida de ganancias, pérdida de datos u otras pérdidas económicas',
  'termsOfService.section9.1.item2': 'Interrupción del negocio',
  'termsOfService.section9.1.item3': 'Lesión corporal o pérdida de propiedad',
  'termsOfService.section9.1.item4': 'Violación de privacidad',
  'termsOfService.section9.2.title': '9.2 Límite de Responsabilidad',
  'termsOfService.section9.2.content': 'Nuestra responsabilidad total no excede el monto total que realmente pagó por este servicio en los últimos 12 meses, o $100 (el monto más alto).',
  'termsOfService.section10.title': 'X. Terminación del Servicio',
  'termsOfService.section10.1.title': '10.1 Terminación por Usuario',
  'termsOfService.section10.1.content': 'Puede dejar de usar este servicio y cancelar su cuenta en cualquier momento.',
  'termsOfService.section10.2.title': '10.2 Terminación por Plataforma',
  'termsOfService.section10.2.intro': 'Tenemos el derecho de terminar o suspender inmediatamente su cuenta y servicio en las siguientes circunstancias:',
  'termsOfService.section10.2.item1': 'Usted viola estos Términos de Servicio',
  'termsOfService.section10.2.item2': 'Usted se dedica a actividades ilegales',
  'termsOfService.section10.2.item3': 'Su cuenta no se ha utilizado durante un largo período',
  'termsOfService.section10.2.item4': 'Requisitos legales o regulatorios',
  'termsOfService.section10.2.note': 'Después de la terminación del servicio, no podrá acceder a su cuenta y contenido generado, a menos que la ley disponga lo contrario.',
  'termsOfService.section11.title': 'XI. Resolución de Disputas',
  'termsOfService.section11.1.title': '11.1 Negociación',
  'termsOfService.section11.1.content': 'Si ocurre una disputa, ambas partes deben intentar primero resolverla mediante negociación amistosa.',
  'termsOfService.section11.2.title': '11.2 Ley Aplicable',
  'termsOfService.section11.2.content': 'Estos Términos de Servicio se rigen por las leyes de la República Popular China. Si ambas partes no pueden resolver la disputa mediante negociación, se someterá a un tribunal popular con jurisdicción en nuestra ubicación.',
  'termsOfService.section12.title': 'XII. Otras Disposiciones',
  'termsOfService.section12.1.title': '12.1 Modificación de Términos',
  'termsOfService.section12.1.content': 'Nos reservamos el derecho de modificar estos Términos de Servicio en cualquier momento. Los cambios importantes se le notificarán al menos 30 días antes de que entren en vigor. El uso continuado del servicio indica su aceptación de los términos modificados.',
  'termsOfService.section12.2.title': '12.2 Divisibilidad',
  'termsOfService.section12.2.content': 'Si alguna disposición de estos Términos de Servicio se considera inválida o inaplicable, no afecta la validez de las otras disposiciones.',
  'termsOfService.section12.3.title': '12.3 Acuerdo Completo',
  'termsOfService.section12.3.content': 'Estos Términos de Servicio constituyen el acuerdo completo entre usted y nosotros con respecto al uso de este servicio, reemplazando todos los acuerdos orales o escritos anteriores.',
  'termsOfService.section13.title': 'XIII. Contáctenos',
  'termsOfService.section13.intro': 'Si tiene preguntas sobre estos Términos de Servicio, contáctenos a través de los siguientes métodos:',
  'termsOfService.section13.email': 'Correo electrónico: {email}',
  'termsOfService.section13.hours': 'Horario de atención al cliente: días laborables 9:00-18:00',
  
  // Footer
  'footer.brand.description': 'Proporciona servicios de generación con IA.',
  'footer.joinUs': 'Únete',
  'footer.product.title': 'Producto',
  'footer.product.signup': 'Registrarse',
  'footer.product.login': 'Iniciar sesión',
  'footer.product.workspace': 'Espacio de trabajo',
  'footer.product.works': 'Mis obras',
  'footer.support.title': 'Soporte',
  'footer.support.help': 'Centro de ayuda',
  'footer.support.about': 'Acerca de nosotros',
  'footer.support.feedback': 'Comentarios',
  'footer.support.contact': 'Contáctenos',
  'footer.legal.title': 'Legal',
  'footer.legal.privacy': 'Política de privacidad',
  'footer.legal.terms': 'Términos de servicio',
  'footer.legal.recharge': 'Acuerdo de recarga',
  'footer.resources.title': 'Recursos',
  'footer.resources.invite': 'Invitar amigos',
  'footer.resources.account': 'Gestión de cuenta',
  'footer.resources.orders': 'Centro de pedidos',
  'footer.copyright': '© {year} {brand}. Todos los derechos reservados.',
  'footer.description': 'Esta plataforma proporciona servicios de generación con IA',
  'footer.openRobotX.title': 'Open Robot X',
  'footer.openRobotX.description': 'Base de datos global de robótica humanoide con comparación de especificaciones e información de la industria',
  'footer.openRobotX.visit': 'Visitar Open Robot X',
  'footer.ai2obj.title': 'ai2obj',
  'footer.ai2obj.description': 'Plataforma integral de generación con IA para crear diversos contenidos digitales',
  'footer.aimatexMusic.title': 'AIMATEX-MUSIC',
  'footer.aimatexMusic.description': 'Música en la nube: descubrir, playlists, reproducción y biblioteca',
  
  // Página de precios
  'pricing.title': 'Elija el plan que funcione para usted',
  'pricing.plan.basic.sub': 'Básico',
  'pricing.plan.pro.sub': 'Pro',
  'pricing.plan.team.sub': 'Equipo',
  'pricing.plan.popular': 'POPULAR',
  'pricing.plan.button.select': 'Seleccionar plan',
  'pricing.plan.button.subscribe': 'Suscribirse ahora',
  'pricing.plan.basic.videoQuota': '5/mes',
  'pricing.plan.basic.videoDuration': '6-10s',
  'pricing.plan.basic.videoQuality': '720P',
  'pricing.plan.pro.videoQuota': '30/mes',
  'pricing.plan.pro.videoDuration': '10-15s',
  'pricing.plan.pro.videoQuality': '1080P',
  'pricing.plan.team.videoQuota': '100/mes',
  'pricing.plan.team.videoDuration': '10-15s',
  'pricing.plan.team.videoQuality': '1080P/4K',
  'pricing.feature.videoQuota': 'Cuota de generación de video',
  'pricing.feature.videoDuration': 'Duración del video',
  'pricing.feature.videoQuality': 'Calidad del video',
  'pricing.feature.storyboard': 'Storyboard',
  'pricing.feature.workflow': 'Flujo de trabajo',
  'pricing.feature.priorityQueue': 'Cola prioritaria',
  'pricing.feature.exclusiveChannel': 'Canal exclusivo',
  'pricing.feature.highestQuality': 'Modo de máxima calidad',
  'pricing.feature.sdImage': 'Generación de imágenes SD',
  'pricing.feature.unlimited': 'Ilimitado',
  'pricing.feature.promptOptimization': 'Optimización de prompts',
  'pricing.feature.imageSize': 'Tamaño de imagen',
  'pricing.feature.storage': 'Espacio de almacenamiento',
  'pricing.feature.commercialLicense': 'Licencia comercial',
  'pricing.feature.apiAccess': 'Acceso API',
  'pricing.then': 'luego',
  'cta.title': 'Comienza a crear tus videos',
  'cta.description': 'Regístrate ahora y transforma tu creatividad en obras de video impresionantes con tecnología IA',
  'cta.button': 'Comenzar gratis',
  'technology.coreArchitecture': 'ARQUITECTURA CORE',
  'technology.workflowEngine.title': 'Motor de Flujo de Trabajo Visual',
  'technology.workflowEngine.description': 'Soporte de flujo de trabajo visual próximamente. Cada nodo es un control preciso sobre la creatividad.',
  'technology.node.checkpointLoader': 'Checkpoint Loader',
  'technology.node.clipTextPositive': 'CLIP Text (Positive)',
  'technology.node.clipTextNegative': 'CLIP Text (Negative)',
  'technology.node.ksamplerAdvanced': 'KSampler Advanced',
  'technology.node.vaeDecode': 'VAE Decode',
  'technology.node.previewImage': 'Preview Image',
  'technology.hud.systemResourceMonitor': 'Monitor de Recursos del Sistema',
  'technology.hud.gpuVram': 'GPU VRAM',
  'technology.terminal.console': 'console — zsh',
  'technology.button.runWorkflow': 'Ejecutar Flujo de Trabajo',
  'technology.button.running': 'Ejecutando...',
  'technology.log.systemInitialized': '> Sistema inicializado.',
  'technology.log.waitingForInput': '> Esperando entrada del usuario...',
  'technology.log.loadingCheckpoint': 'Loading SDXL Checkpoint (fp16)...',
  'technology.log.tokenizingPrompt': 'Tokenizing positive prompt...',
  'technology.log.ksamplerSteps': 'KSampler: 30/30 steps (Euler A)',
  'technology.log.generationComplete': 'Generation complete.',
  'technology.benchmark.title': 'Benchmark de Rendimiento Definitivo',
  'technology.benchmark.description': 'Por esta mejora de 0.5 segundos, reescribimos el 30% de los operadores subyacentes.',
  'technology.benchmark.fps.title': 'Velocidad de Generación (FPS)',
  'technology.benchmark.fps.subtitle': 'Comparison @ 1080p',
  'technology.benchmark.vram.title': 'Optimización VRAM',
  'technology.benchmark.vram.subtitle': 'Lower is better',
  'technology.benchmark.productX': 'ProductX',
  'technology.benchmark.others': 'Others',
  'technology.benchmark.standard': 'Standard',
  'technology.galaxy.openEcology': 'ECOLOGÍA ABIERTA',
  'technology.galaxy.title': 'Universo Infinito de Modelos',
  'technology.galaxy.description': 'Soporte para conexión directa de Civitai, miles de modelos, carga con un clic.',
  'technology.galaxy.autoSync': 'Auto-Sync',
  
  // Página de comentarios
  'feedback.leftPanel.title.line1': 'Escuchamos',
  'feedback.leftPanel.title.line2': 'Tu voz',
  'feedback.leftPanel.description': 'Tus comentarios son la fuerza impulsora detrás de la mejora de nuestro producto. Ya sea que hayas encontrado un error o tengas una idea brillante para una nueva función, háznoslo saber.',
  'feedback.contact.helpDoc.title': 'Documentación de ayuda',
  'feedback.contact.helpDoc.desc': 'Consultar preguntas frecuentes y guías de usuario',
  'feedback.contact.email.title': 'Soporte por correo',
  'feedback.contact.service.title': 'Soporte en línea',
  'feedback.contact.service.hours': 'Días laborables 9:00 - 18:00',
  'feedback.type.suggestion.title': 'Sugerencia de función',
  'feedback.type.suggestion.desc': 'Tengo nuevas ideas o sugerencias de mejora',
  'feedback.type.bug.title': 'Informe de error',
  'feedback.type.bug.desc': 'Encontré un error o excepción',
  'feedback.type.question.title': 'Consulta de uso',
  'feedback.type.question.desc': 'No entiendo cómo usar una función',
  'feedback.type.other.title': 'Otro',
  'feedback.type.other.desc': 'Otros tipos de comentarios',
  'feedback.form.type.label': 'Tipo de comentario',
  'feedback.form.title.label': 'Resumen breve',
  'feedback.form.title.placeholder': 'Describe tu problema o sugerencia en una oración',
  'feedback.form.title.required': 'Por favor ingresa un título',
  'feedback.form.content.label': 'Descripción detallada',
  'feedback.form.content.placeholder': 'Por favor describe el contexto, pasos de reproducción o sugerencias específicas...',
  'feedback.form.content.required': 'Por favor ingresa contenido detallado',
  'feedback.form.attachment.label': 'Adjuntos (Opcional)',
  'feedback.upload.dragText': 'Haz clic o arrastra archivos aquí para subir',
  'feedback.upload.hint': 'Soporta formatos JPG, PNG, PDF y otros, tamaño de archivo único no superior a 5MB',
  'feedback.upload.sizeLimit': 'El tamaño del archivo no puede exceder 5MB',
  'feedback.form.priority.label': 'Prioridad',
  'feedback.priority.low.label': 'Baja',
  'feedback.priority.low.desc': 'No afecta el uso',
  'feedback.priority.medium.label': 'Media',
  'feedback.priority.medium.desc': 'Afecta la experiencia del usuario',
  'feedback.priority.high.label': 'Alta',
  'feedback.priority.high.desc': 'Obstaculiza seriamente el uso',
  'feedback.form.contact.label': 'Información de contacto (Opcional)',
  'feedback.form.contact.placeholder': 'Correo electrónico o número de teléfono',
  'feedback.form.submit': 'Enviar comentarios',
  'feedback.submit.error': 'Error al enviar, por favor inténtalo de nuevo más tarde',
  'feedback.success.title': '¡Comentarios recibidos!',
  'feedback.success.description': 'Gracias por tus valiosos comentarios. Nuestro equipo de producto leerá cuidadosamente cada comentario. Si es un informe de error, podemos contactarte a través de la información de contacto proporcionada.',
  'feedback.success.back': 'Volver',
  'feedback.success.another': 'Enviar otro',
  // Página de invitación
  'invite.partnerProgram': 'Programa de Socios',
  'invite.title.line1': 'Invita amigos',
  'invite.title.line2': 'Crea valor ilimitado',
  'invite.reward.inviter': 'Gana {amount} de recompensa en efectivo por cada amigo invitado.',
  'invite.reward.invitee': 'Tu amigo recibe {amount} de bono de bienvenida al registrarse.',
  'invite.step1.title': '1. Comparte el enlace',
  'invite.step1.desc': 'Comparte tu enlace exclusivo en redes sociales',
  'invite.step2.title': '2. Amigo se activa',
  'invite.step2.desc': 'El amigo completa registro y verificación',
  'invite.step3.title': '3. Retira ganancias',
  'invite.step3.desc': 'Ganancias instantáneas, retiro a saldo',
  'invite.exclusiveCode': 'TU CÓDIGO EXCLUSIVO',
  'invite.copyCode': 'Copiar código',
  'invite.viewQrcode': 'Ver código QR',
  'invite.stats.totalInvites': 'Total invitados',
  'invite.stats.availableReward': 'Saldo disponible',
  'invite.stats.totalReward': 'Ganancias totales',
  'invite.withdrawNow': 'Retirar ahora',
  'invite.history.title': 'Historial de invitaciones',
  'invite.filter.all': 'Todos',
  'invite.filter.active': 'Activos',
  'invite.filter.pending': 'Pendientes',
  'invite.status.credited': 'Acreditado',
  'invite.status.pending': 'Pendiente',
  'invite.history.empty': 'Sin registros',
  'invite.withdraw.title': 'Retirar ganancias',
  'invite.withdraw.cancel': 'Cancelar',
  'invite.withdraw.confirm': 'Confirmar retiro',
  'invite.withdraw.amount': 'Monto de retiro',
  'invite.withdraw.note': '* El monto se transferirá directamente a tu saldo de cuenta.',
  'invite.withdraw.enterAmount': 'Por favor ingresa el monto de retiro',
  'invite.withdraw.insufficientBalance': 'Saldo insuficiente',
  'invite.withdraw.success': '¥{amount} retirados exitosamente al saldo',
  'invite.qrcode.title': 'Escanea para unirte',
  'invite.copyLink': 'Copiar enlace',
  'invite.copy.success': 'Copiado exitosamente',
  // Sección Hero de la página de inicio
  'home.hero.badge': 'Asistente IA · Compañero · Socio',
  'home.hero.title': 'AIMATEX',
  'home.hero.subtitle': 'Tu Compañero de Clase, Alma Gemela, Compañero de Equipo',
  'home.hero.description': 'AIMATEX es tu asistente de IA, compañero de aprendizaje y compañero creativo. Proporcionamos soluciones de IA integrales, haciendo que la IA sea tu mejor socio en el trabajo, estudio y creación. Ya sea aprendizaje en el aula, colaboración creativa o cooperación en equipo, AIMATEX es tu socio de confianza.',
  'home.hero.cta.signup': 'Comenzar gratis',
  'home.hero.cta.login': 'Iniciar sesión',
  'home.hero.cta.workspace': 'Ir al espacio de trabajo',
  // Sección de productos de la página de inicio
  'home.products.title': 'Nuestros Productos',
  'home.products.subtitle': 'Explora productos de IA innovadores bajo AIMATEX, cada producto es tu mejor socio en diferentes escenarios',
  'home.products.seedance2.name': 'Seedance2',
  'home.products.seedance2.description': 'Socio de creación de imagen a video con IA, transformando imágenes estáticas en videos dinámicos, dando vida a tu creatividad',
  'home.products.ai2obj.name': 'AI2Obj',
  'home.products.ai2obj.description': 'Plataforma de generación y conversión de objetos 3D impulsada por IA, tu socio de creación 3D',
  'home.products.openrobotx.name': 'OpenRobotX',
  'home.products.openrobotx.description': 'Explora empresas globales de robots humanoides, comparaciones de parámetros e información de la industria, tu socio de investigación en robótica',
  'home.products.openclaw4j.name': 'OpenClaw4j',
  'home.products.openclaw4j.title': 'OpenClaw4j',
  'home.products.openclaw4j.description': 'Plataforma de agentes autónomos — construye y despliega agentes inteligentes con OpenForgeX.',
  'home.products.openclaw4j.cta': 'Probar agente',
  'home.products.aimatexMusic.name': 'AIMATEX-MUSIC',
  'home.products.aimatexMusic.title': 'AIMATEX-MUSIC',
  'home.products.aimatexMusic.description': 'Espacio de música en la nube personal — descubrir canciones, playlists colaborativas, reproduciendo ahora y biblioteca en la nube',
  'home.products.aimatexMusic.cta': 'Entrar a la música',
  'home.music.eyebrow': 'Suite AIMATEX',
  'home.music.title': 'AIMATEX-MUSIC',
  'home.music.subtitle': 'Tu espacio de música en la nube — descubrir, coleccionar y escuchar juntos.',
  'home.music.feature.discover.title': 'Descubrir',
  'home.music.feature.discover.desc': 'Busca e importa canciones a tu biblioteca.',
  'home.music.feature.playlist.title': 'Playlists',
  'home.music.feature.playlist.desc': 'Crea y comparte playlists colaborativas.',
  'home.music.feature.nowPlaying.title': 'Reproduciendo',
  'home.music.feature.nowPlaying.desc': 'Escucha sincronizada, favoritos e historial.',
  'home.music.feature.cloud.title': 'Biblioteca cloud',
  'home.music.feature.cloud.desc': 'Audio de alta calidad guardado en la nube.',
  'home.music.cta': 'Abrir AIMATEX-MUSIC',
'home.showcase.seedance2.eyebrow': 'Image to Video',
  'home.showcase.seedance2.title': 'Seedance2',
  'home.showcase.seedance2.subtitle': 'Turn still frames into cinematic motion with a next-gen creation engine.',
  'home.showcase.seedance2.f1.title': 'Image to Video',
  'home.showcase.seedance2.f1.desc': 'Upload a photo — AI invents light and motion.',
  'home.showcase.seedance2.f2.title': 'Cinema Quality',
  'home.showcase.seedance2.f2.desc': 'High-res output with stable, crisp detail.',
  'home.showcase.seedance2.f3.title': 'Smart Prompts',
  'home.showcase.seedance2.f3.desc': 'AI polishes rough ideas into film-ready prompts.',
  'home.showcase.seedance2.f4.title': 'Style Switch',
  'home.showcase.seedance2.f4.desc': 'Cyberpunk, oil paint, anime — one click.',
  'home.showcase.seedance2.cta': 'Enter Seedance2',
  'home.showcase.ai2obj.eyebrow': '3D Generation',
  'home.showcase.ai2obj.title': 'AI2Obj',
  'home.showcase.ai2obj.subtitle': 'An AI generation platform that turns ideas into usable digital assets.',
  'home.showcase.ai2obj.f1.title': 'Multimodal',
  'home.showcase.ai2obj.f1.desc': 'From text and images to 3D and content assets.',
  'home.showcase.ai2obj.f2.title': 'Object Convert',
  'home.showcase.ai2obj.f2.desc': 'Structure understanding and format conversion.',
  'home.showcase.ai2obj.f3.title': 'Creator Workflow',
  'home.showcase.ai2obj.f3.desc': 'Pipelines built for product and content teams.',
  'home.showcase.ai2obj.f4.title': 'Cloud Delivery',
  'home.showcase.ai2obj.f4.desc': 'Preview, export, and collaborate in the cloud.',
  'home.showcase.ai2obj.cta': 'Visit AI2Obj',
  'home.showcase.openrobotx.eyebrow': 'Robotics Intel',
  'home.showcase.openrobotx.title': 'OpenRobotX',
  'home.showcase.openrobotx.subtitle': 'Global humanoid robot companies, specs, and industry insights in one place.',
  'home.showcase.openrobotx.f1.title': 'World Map',
  'home.showcase.openrobotx.f1.desc': 'Major humanoid vendors and products covered.',
  'home.showcase.openrobotx.f2.title': 'Spec Compare',
  'home.showcase.openrobotx.f2.desc': 'Clear side-by-side capability and positioning.',
  'home.showcase.openrobotx.f3.title': 'Industry News',
  'home.showcase.openrobotx.f3.desc': 'Funding, launches, and tech movements tracked.',
  'home.showcase.openrobotx.f4.title': 'Research Partner',
  'home.showcase.openrobotx.f4.desc': 'Structured intel for selection and research.',
  'home.showcase.openrobotx.cta': 'Explore OpenRobotX',
  'home.showcase.openclaw4j.eyebrow': 'Autonomous Agents',
  'home.showcase.openclaw4j.title': 'OpenClaw4j',
  'home.showcase.openclaw4j.subtitle': 'Build and deploy intelligent agents with OpenForgeX — make agents run for real.',
  'home.showcase.openclaw4j.f1.title': 'Agent Orchestration',
  'home.showcase.openclaw4j.f1.desc': 'Multi-step planning and execution.',
  'home.showcase.openclaw4j.f2.title': 'Tool Calling',
  'home.showcase.openclaw4j.f2.desc': 'Connect APIs and business systems.',
  'home.showcase.openclaw4j.f3.title': 'Observable Runs',
  'home.showcase.openclaw4j.f3.desc': 'Transparent traces for debug and iteration.',
  'home.showcase.openclaw4j.f4.title': 'One-click Deploy',
  'home.showcase.openclaw4j.f4.desc': 'From prototype to live service fast.',
  'home.showcase.openclaw4j.cta': 'Try Agent',
  'home.products.learnMore': 'Saber más',
  // Sección de características de la página de inicio
  'home.features.title': 'Taller creativo todo en uno.',
  'home.features.subtitle': 'Más que solo generación de videos, es un empoderamiento creativo integral.',
  'home.features.aiPrompt.title': '¿No puedes escribir prompts? IA lo escribe por ti',
  'home.features.aiPrompt.description': '¿Completamente sin ideas? Deja que la IA escriba por ti con un clic. Solo escribe algunas palabras, la IA las pule automáticamente en descripciones cinematográficas, 10 segundos para generar. ¿Quieres cambiar el estilo? Haz clic de nuevo, transforma instantáneamente a cyberpunk/pintura al óleo/anime.',
  'home.features.demo.userInput': 'un gato',
  'home.features.demo.aiResult': 'Un elegante gato persa con pelaje largo y esponjoso blanco, ojos ámbar, sentado en un alféizar soleado. El fondo presenta un cielo azul claro y cortinas blancas flotantes. 4K ultra HD, iluminación cinematográfica, profundidad de campo, fotografía profesional.',
  'home.features.demo.buttonText': 'Generar IA',
  'home.features.demo.buttonLoading': 'Generando',
  'home.features.demo.thinkingText': 'IA creando✨',
  'home.features.quality.title': 'Calidad cinematográfica',
  'home.features.quality.description': 'Soporte nativo para salida de resolución 4K, cada fotograma es delicadamente elaborado.',
  'home.features.imageToVideo.title': 'Imagen a video',
  'home.features.imageToVideo.description': 'Sube una imagen estática, la IA comprende la iluminación y la física en la escena, genera automáticamente dinámicas posteriores, dando vida a las fotos.',
  'home.features.multimodal.title': 'Ecosistema multimodal',
  'home.features.multimodal.description': 'No solo admite Stable Diffusion de texto a imagen, sino que también integra la transferencia de estilo de Midjourney y la síntesis de audio de ElevenLabs. Completa todas las creaciones en un flujo de trabajo.',
  
  // Sección de comunidad de inicio
  'home.community.title': 'Explora comunidades creativas de IA',
  'home.community.subtitle': 'Únete a millones de creadores, comparte tus obras maestras de IA y obtén inspiración y comentarios',
  'home.community.hot': 'Popular',
  'home.community.explore': 'Explorar comunidad',
  'home.community.stats.works': 'Obras',
  'home.community.stats.creators': 'Creadores',
  'home.community.stats.views': 'Vistas',
  'home.community.image.title': 'Comunidad de imágenes IA',
  'home.community.image.description': 'Descubre y comparte impresionantes imágenes generadas por IA, desde fotorrealistas hasta artísticas, desde ilustraciones hasta fotografía',
  'home.community.video.title': 'Comunidad de videos IA',
  'home.community.video.description': 'Explora increíbles videos generados por IA, aprende técnicas creativas e intercambia experiencias con creadores de video globales',
  'home.community.music.title': 'Comunidad de música IA',
  'home.community.music.description': 'Escucha hermosas melodías compuestas por IA, comparte tus obras musicales y encuentra entusiastas de la música afines',
  'home.community.3d.title': 'Comunidad de modelos 3D IA',
  'home.community.3d.description': 'Explora el mundo de los modelos 3D generados por IA, desde arquitectura hasta personajes, desde juegos hasta diseño industrial',
  'home.community.voice.title': 'Comunidad de voz IA',
  'home.community.voice.description': 'Experimenta síntesis de voz IA realista, doblaje, audiolibros, clonación de voz y da vida a tus creaciones',
  'home.community.text.title': 'Comunidad de texto IA',
  'home.community.text.description': 'Comparte excelentes textos creados por IA, novelas, poemas, guiones, textos publicitarios e inspira tu creatividad literaria',
  
  // Página de facturación
  'billing.page.title': 'Centro financiero',
  'billing.page.description': 'Gestione sus transacciones y detalles de facturación',
  'billing.button.refresh': 'Actualizar',
  'billing.button.recharge': 'Recargar',
  'billing.button.reset': 'Restablecer',
  'billing.button.apply': 'Aplicar filtros',
  'billing.balance.cny': 'Saldo CNY',
  'billing.balance.usdt': 'Saldo USDT',
  'billing.balance.usd': 'Saldo USD',
  'billing.balance.token': 'Saldo de Token',
  'billing.balance.frozen': 'Congelado',
  'billing.type.frozen': 'Fondos congelados',
  'billing.type.aiModelFee': 'Tarifa de modelo IA',
  'billing.type.recharge': 'Recarga',
  'billing.type.refund': 'Reembolso',
  'billing.type.reward': 'Recompensa',
  'billing.type.all': 'Todos los tipos',
  'billing.coin.all': 'Todas las monedas',
  'billing.coin.usdt': 'USDT',
  'billing.coin.cny': 'CNY',
  'billing.coin.usd': 'USD',
  'billing.coin.token': 'TOKEN',
  'billing.table.type': 'Tipo',
  'billing.table.coinType': 'Moneda',
  'billing.table.time': 'Hora',
  'billing.table.amount': 'Cantidad',
  'billing.table.remark': 'Observación',
  'billing.table.balance': 'Saldo',
  'billing.table.empty': 'Sin registros',
  'billing.filter.title': 'Opciones de filtro',
  'billing.filter.button': 'Filtrar y fecha',
  'billing.filter.changeType': 'Tipo de transacción',
  'billing.filter.coinType': 'Tipo de moneda',
  'billing.filter.remark': 'Búsqueda de observaciones',
  'billing.filter.remarkPlaceholder': 'Ingrese palabras clave',
  'billing.filter.remarkSearch': 'Búsqueda de observaciones',
  'billing.filter.dateQuick': 'Fecha rápida',
  'billing.filter.dateCustom': 'Fecha personalizada',
  'billing.filter.dateTo': 'a',
  'billing.filter.days7': 'Últimos 7 días',
  'billing.filter.days30': 'Últimos 30 días',
  'billing.filter.days90': 'Últimos 3 meses',
  'billing.placeholder.changeType': 'Tipo de cambio',
  'billing.placeholder.coinType': 'Moneda',
  'billing.placeholder.remark': 'Búsqueda de observaciones',
  'billing.message.fetchBalanceError': 'Error al obtener saldo',
  'billing.message.fetchRecordsError': 'Error al obtener registros de facturación',
  'billing.message.tryAgain': 'Error al obtener registros de facturación, intente nuevamente más tarde',
  
  // Página de recarga
  'recharge.page.title': 'Recarga de cuenta',
  'recharge.page.backLink': 'Volver a facturación',
  'recharge.balance.title': 'Saldo de cuenta',
  'recharge.balance.refresh': 'Actualizar',
  'recharge.section.coinType': 'Moneda de recarga',
  'recharge.section.paymentMethod': 'Método de pago',
  'recharge.section.amount': 'Cantidad de recarga',
  'recharge.order.title': 'Detalles del pedido',
  'recharge.order.type': 'Tipo de recarga',
  'recharge.order.typeValue': 'Recarga de saldo de cuenta',
  'recharge.order.account': 'Cuenta',
  'recharge.order.accountLoading': 'Cargando...',
  'recharge.order.paymentMethod': 'Método de pago',
  'recharge.order.paymentMethodPlease': 'Por favor seleccione',
  'recharge.order.total': 'Cantidad total',
  'recharge.button.pay': 'Pagar ahora',
  'recharge.button.customize': 'Cantidad personalizada',
  'recharge.placeholder.customAmount': 'Ingrese cantidad personalizada',
  'recharge.security.ssl': 'Transmisión cifrada SSL, pago seguro',
  'recharge.security.agreement': 'Al hacer clic en Pagar, acepta',
  'recharge.security.agreementLink': 'Acuerdo de servicio de recarga',
  'recharge.empty.noCurrency': 'No hay monedas compatibles',
  'recharge.empty.noPaymentMethod': 'Ningún método de pago disponible para {currency}',
  'recharge.empty.pleaseSelectCurrency': 'Por favor seleccione primero la moneda',
  'recharge.empty.pleaseSelectPayment': 'Por favor seleccione primero el método de pago',
  'recharge.empty.noProducts': 'No hay productos disponibles',
  'recharge.empty.noPresets': 'No hay cantidades preestablecidas para {currency}',
  'recharge.message.invalidAmount': 'Por favor ingrese una cantidad válida',
  'recharge.message.selectPaymentMethod': 'Por favor seleccione un método de pago',
  'recharge.message.selectAmount': 'Por favor seleccione la cantidad de recarga',
  'recharge.message.fetchBalanceError': 'Error al obtener saldo, intente nuevamente más tarde',
  'recharge.message.fetchUserInfoError': 'Error al obtener información del usuario',
  'recharge.message.fetchCurrenciesError': 'Error al obtener monedas, intente nuevamente más tarde',
  'recharge.message.fetchPaymentMethodsError': 'Error al obtener métodos de pago, intente nuevamente más tarde',
  'recharge.message.fetchCreemProductsError': 'Error al obtener productos Creem, intente nuevamente más tarde',
  'recharge.message.fetchCreemProductsWarning': 'Error al obtener productos Creem',
  'recharge.message.orderCreated': 'Pedido creado exitosamente',
  'recharge.message.orderCreateFailed': 'Error al crear pedido de recarga',
  'recharge.message.paymentProcessing': 'Abriendo página de pago, complete el pago...',
  'recharge.message.popupBlocked': 'No se puede abrir la ventana de pago, verifique la configuración de ventanas emergentes del navegador',
  'recharge.message.paymentUrlError': 'Error al obtener URL de pago',
  'recharge.message.checkoutSessionError': 'Error al crear sesión de pago',
  'recharge.message.paymentError': 'Error al procesar el pago, intente nuevamente más tarde',
  'recharge.message.redirecting': 'Redirigiendo a la página de pago, complete el pago...',
  'recharge.message.paymentUrlFailed': 'URL de pago no disponible',
  'recharge.message.paymentSuccess': '¡Pago exitoso! Saldo actualizado',
  'recharge.message.orderCancelled': 'Pedido cancelado',
  'recharge.message.paymentFailed': 'Pago fallido',
  'recharge.message.orderExpired': 'Expirado',
  'recharge.message.queryOrderError': 'Error al consultar el estado del pedido',
  'recharge.message.rechargeError': 'Error en solicitud de recarga, intente nuevamente más tarde',

  // Página de pedidos
  'orders.title': 'Historial de pedidos',
  'orders.subtitle': 'Ver todos sus registros de pedidos de recarga y estados',
  'orders.refresh': 'Actualizar',
  'orders.goToRecharge': 'Recargar',

  // Tarjetas estadísticas
  'orders.stats.totalOrders': 'Total de pedidos',
  'orders.stats.pending': 'Pendiente',
  'orders.stats.paid': 'Pagado',
  'orders.stats.totalAmount': 'Total recargado',

  // Columnas de tabla
  'orders.table.orderNo': 'N° de pedido',
  'orders.table.createTime': 'Creado el',
  'orders.table.amount': 'Monto',
  'orders.table.paymentMethod': 'Método de pago',
  'orders.table.status': 'Estado',
  'orders.table.action': 'Acción',
  'orders.table.view': 'Ver',
  'orders.table.cancel': 'Cancelar',
  'orders.table.empty': 'Sin registros de pedidos',

  // Estado del pedido
  'orders.status.pending': 'Pendiente',
  'orders.status.paid': 'Pagado',
  'orders.status.success': 'Completado',
  'orders.status.cancelled': 'Cancelado',
  'orders.status.failed': 'Fallido',
  'orders.status.expired': 'Expirado',
  'orders.status.all': 'Todos los estados',

  // Métodos de pago
  'orders.payment.alipay': 'Alipay',
  'orders.payment.wechat': 'WeChat Pay',
  'orders.payment.bank': 'Tarjeta bancaria',
  'orders.payment.usdt': 'USDT',
  'orders.payment.creem': 'Creem',
  'orders.payment.all': 'Todos los métodos',

  // Moneda
  'orders.coin.all': 'Todas las monedas',

  // Filtros
  'orders.filter.title': 'Opciones de filtro',
  'orders.filter.button': 'Filtrar pedidos',
  'orders.filter.reset': 'Restablecer',
  'orders.filter.apply': 'Aplicar',
  'orders.filter.orderStatus': 'Estado del pedido',
  'orders.filter.paymentMethod': 'Método de pago',
  'orders.filter.coinType': 'Tipo de moneda',
  'orders.filter.orderNoSearch': 'Buscar N° de pedido',
  'orders.filter.quickDate': 'Fecha rápida',
  'orders.filter.customDate': 'Fecha personalizada',
  'orders.filter.dateTo': 'a',
  'orders.filter.last7Days': 'Últimos 7 días',
  'orders.filter.last30Days': 'Últimos 30 días',
  'orders.filter.last3Months': 'Últimos 3 meses',

  // Búsqueda y entrada
  'orders.search.placeholder': 'Buscar número de pedido',
  'orders.input.orderNo': 'Ingresar número de pedido',
  'orders.select.orderStatus': 'Estado del pedido',
  'orders.select.paymentMethod': 'Método de pago',
  'orders.select.coinType': 'Moneda',

  // Mensajes
  'orders.message.fetchError': 'Error al obtener pedidos',
  'orders.message.fetchErrorRetry': 'Error al obtener pedidos, intente nuevamente más tarde',
  'orders.message.statsError': 'Error al obtener estadísticas',
  'orders.message.cancelSuccess': 'Pedido cancelado',
  'orders.message.cancelError': 'Error al cancelar pedido',
  'orders.message.cancelErrorRetry': 'Error al cancelar pedido, intente nuevamente más tarde',
  'orders.message.viewOrder': 'N° de pedido: {orderNo}',

  // Diálogo de confirmación
  'orders.confirm.cancel': '¿Está seguro de que desea cancelar este pedido?',
  'orders.confirm.ok': 'OK',
  'orders.confirm.cancelButton': 'Cancelar',

  // Página Únete a nosotros
  'joinUs.seo.title': 'Únete a PROTX - Búsqueda de la excelencia',
  'joinUs.seo.description': 'Únete al equipo PROTX y persigue la experiencia de usuario y el diseño de producto definitivos con nosotros',
  'joinUs.hero.eyebrow': 'JOIN PROTX',
  'joinUs.hero.title': 'Búsqueda de la excelencia',
  'joinUs.hero.title2': 'Definiendo el futuro a través del diseño',
  'joinUs.hero.subtitle': 'PROTX es un equipo dedicado a crear la experiencia de usuario y el diseño de producto definitivos. Creemos que cada píxel importa, cada interacción merece ser pulida meticulosamente. Si compartes nuestra búsqueda incansable de la excelencia, únete a nosotros.',
  'joinUs.hero.cta': 'Ver posiciones abiertas',
  'joinUs.hero.video': 'Ver nuestra historia',
  
  'joinUs.values.eyebrow': 'NUESTROS VALORES',
  'joinUs.values.title': 'Nuestros valores fundamentales',
  'joinUs.values.subtitle': 'Estos valores fundamentales definen quiénes somos y cómo trabajamos juntos',
  'joinUs.values.innovation.title': 'Impulsados por la innovación',
  'joinUs.values.innovation.desc': 'Creemos que la innovación es la fuerza que cambia el mundo, fomentando cada idea revolucionaria.',
  'joinUs.values.collaboration.title': 'Éxito colaborativo',
  'joinUs.values.collaboration.desc': 'Colaboración entre equipos para crear resultados extraordinarios juntos.',
  'joinUs.values.excellence.title': 'Búsqueda de la excelencia',
  'joinUs.values.excellence.desc': 'Superando constantemente los límites para la experiencia definitiva.',
  'joinUs.values.passion.title': 'Pasión y enfoque',
  'joinUs.values.passion.desc': 'Amor por la tecnología, dedicación al producto.',
  'joinUs.values.impact.title': 'Generando impacto',
  'joinUs.values.impact.desc': 'Potenciando la expresión creativa de todos con tecnología IA.',
  
  'joinUs.positions.eyebrow': 'POSICIONES ABIERTAS',
  'joinUs.positions.title': 'Posiciones abiertas',
  'joinUs.positions.subtitle': 'Encuentra el rol que te conviene y comienza tu nuevo viaje profesional',
  'joinUs.category.engineering': 'Ingeniería',
  'joinUs.category.product': 'Producto y Diseño',
  'joinUs.category.operations': 'Operaciones y Marketing',
  'joinUs.position.seniorFrontend': 'Ingeniero Frontend Senior',
  'joinUs.position.backendEngineer': 'Ingeniero Backend',
  'joinUs.position.mlEngineer': 'Ingeniero IA/ML',
  'joinUs.position.productManager': 'Product Manager',
  'joinUs.position.uxDesigner': 'Diseñador UX',
  'joinUs.position.communityManager': 'Community Manager',
  'joinUs.position.contentCreator': 'Creador de Contenido',
  'joinUs.location.remote': 'Remoto',
  'joinUs.location.beijing': 'Pekín',
  'joinUs.location.shanghai': 'Shanghái',
  'joinUs.location.shenzhen': 'Shenzhen',
  'joinUs.type.fulltime': 'Tiempo completo',
  'joinUs.type.parttime': 'Tiempo parcial',
  
  'joinUs.benefits.eyebrow': 'BENEFICIOS',
  'joinUs.benefits.title': 'Lo que ofrecemos',
  'joinUs.benefits.subtitle': 'Únete a nosotros y disfruta de beneficios y apoyo integrales',
  'joinUs.benefit.flexible.title': 'Trabajo flexible',
  'joinUs.benefit.flexible.desc': 'Horarios flexibles y opciones de trabajo remoto',
  'joinUs.benefit.equity.title': 'Stock options',
  'joinUs.benefit.equity.desc': 'Crece con la empresa y comparte nuestro éxito',
  'joinUs.benefit.health.title': 'Seguro médico',
  'joinUs.benefit.health.desc': 'Seguro de salud completo y beneficios de bienestar',
  'joinUs.benefit.growth.title': 'Crecimiento profesional',
  'joinUs.benefit.growth.desc': 'Oportunidades continuas de aprendizaje y desarrollo',
  
  'joinUs.cta.title': '¿Listo para empezar?',
  'joinUs.cta.subtitle': 'Si te apasiona nuestra misión, esperamos tu solicitud',
  'joinUs.cta.button': 'Aplicar ahora',
  
  'joinUs.modal.title': 'Solicitud de empleo',
  'joinUs.apply.success': '¡Solicitud enviada! Te contactaremos pronto.',
  'joinUs.form.name': 'Nombre',
  'joinUs.form.name.required': 'Por favor ingresa tu nombre',
  'joinUs.form.name.placeholder': 'Ingresa tu nombre',
  'joinUs.form.email': 'Correo electrónico',
  'joinUs.form.email.required': 'Por favor ingresa tu correo',
  'joinUs.form.email.invalid': 'Por favor ingresa un correo válido',
  'joinUs.form.email.placeholder': 'Ingresa tu correo',
  'joinUs.form.phone': 'Teléfono',
  'joinUs.form.phone.placeholder': 'Ingresa tu número de teléfono',
  'joinUs.form.experience': 'Experiencia laboral',
  'joinUs.form.experience.placeholder': 'Selecciona tu nivel de experiencia',
  'joinUs.form.experience.0-2': '0-2 años',
  'joinUs.form.experience.3-5': '3-5 años',
  'joinUs.form.experience.5-10': '5-10 años',
  'joinUs.form.experience.10+': '10+ años',
  'joinUs.form.resume': 'Currículum',
  'joinUs.form.resume.hint': 'Haz clic o arrastra el archivo para subir',
  'joinUs.form.resume.format': 'Formatos PDF, DOC, DOCX soportados',
  'joinUs.form.message': 'Carta de presentación',
  'joinUs.form.message.placeholder': 'Cuéntanos sobre ti y por qué quieres unirte a nosotros',
  'joinUs.form.submit': 'Enviar solicitud',
  'joinUs.form.loginTip': 'Inicia sesión antes de enviar para ver el historial de solicitudes',
  'joinUs.form.goLogin': 'Iniciar sesión',
  'joinUs.form.resume.sizeLimit': 'El tamaño del archivo no puede superar 10 MB',
  
  // Mis solicitudes
  'joinUs.myApplications.eyebrow': 'MIS SOLICITUDES',
  'joinUs.myApplications.title': 'Historial de solicitudes',
  'joinUs.myApplications.empty': 'Aún no hay solicitudes. ¡Envía tu currículum ahora!',
  'joinUs.myApplications.viewDetail': 'Ver detalles',
  'joinUs.myApplications.detailTitle': 'Detalles de la solicitud',
  'joinUs.status.pending': 'Pendiente',
  'joinUs.status.reviewing': 'En revisión',
  'joinUs.status.interview': 'Entrevista',
  'joinUs.status.accepted': 'Aceptado',
  'joinUs.status.rejected': 'Rechazado',
  'joinUs.detail.basicInfo': 'Información básica',
  'joinUs.detail.positionInfo': 'Información del puesto',
  'joinUs.detail.position': 'Puesto solicitado',
  'joinUs.detail.category': 'Categoría',
  'joinUs.detail.location': 'Ubicación',
  'joinUs.detail.applyTime': 'Fecha de solicitud',
  'joinUs.detail.downloadResume': 'Descargar currículum',
  'joinUs.detail.status': 'Estado de la solicitud',

  // Página About
  'about.hero.title1': 'Núcleo Open Source.',
  'about.hero.title2': 'Posibilidades infinitas.',
  'about.hero.subtitle1': 'Basado en',
  'about.hero.subtitle2': 'y',
  'about.hero.subtitle3': 'ecosistema.',
  'about.hero.description': 'Empaquetamos la pila tecnológica de IA generativa más avanzada de 2025 en una experiencia interactiva definitiva.',
  'about.tech.poweredBy': 'Impulsado por',
  'about.philosophy.title1': 'Más que generación.',
  'about.philosophy.title2': 'Este es un proceso completo',
  'about.philosophy.title3': 'motor de creatividad.',
  'about.philosophy.description': 'Desde el control preciso en texto-a-imagen hasta la simulación física en generación de video, perseguimos los límites de la tecnología.',
  'about.bento.comfy.title': 'Control de precisión a nivel de nodos.',
  'about.bento.comfy.description': 'Construido sobre la arquitectura de nodos ComfyUI, soportando control de pose ControlNet y transferencia de estilo IP-Adapter. Encapsulamos la lógica de nodos compleja en controles deslizantes intuitivos, haciendo que cada generación sea exactamente como imaginas.',
  'about.bento.opensource.title': 'Abrazar el código abierto.',
  'about.bento.opensource.description': 'Basado en Stable Diffusion 3.5 & XL Turbo. No solo generación ultrarrápida, sino también soporte masivo de modelos LoRA de la comunidad.',
  'about.bento.video.title': 'Arquitectura de video DiT.',
  'about.bento.video.description': 'Introduciendo Diffusion Transformer (DiT) con mecanismo de atención espacio-temporal, logrando simulación del mundo físico a nivel SORA.',
  'about.bento.audio.title': 'Sincronización audiovisual, despertar sensorial.',
  'about.bento.audio.description': 'Más allá de lo visual. Integrado con los últimos modelos de generación de audio, soportando Text-to-Audio y alineación automática de video. De la vista al sonido, construyendo una experiencia inmersiva completa.',
  'about.techSection.title': 'Arquitectura técnica.',
  'about.techSection.description': 'Profundiza en el motor central que impulsa ProductX.',
  'about.techCard.sd.title': 'La base del arte generativo.',
  'about.techCard.sd.description': 'Integramos profundamente los últimos modelos de generación Stable Diffusion. A través de VAE personalizado y samplers optimizados, logramos una generación 300% más rápida mientras mantenemos una calidad de imagen exquisita.',
  'about.techCard.spec.baseModel': 'Modelo base',
  'about.techCard.spec.resolution': 'Resolución',
  'about.techCard.spec.resolution.value': 'Hasta 4K Upscaling',
  'about.techCard.spec.control': 'Control',
  'about.techCard.spec.speed': 'Velocidad',
  'about.techCard.spec.speed.value': '< 1s (Modo Turbo)',
  'about.techCard.video.title': 'Motor de física de video de próxima generación.',
  'about.techCard.video.description': 'Abandonando la lógica tradicional de animación 2D, adoptando la última arquitectura DiT (Diffusion Transformer) de 2025. El modelo entiende iluminación, gravedad y física del movimiento, generando no solo videos, sino mundos dinámicos físicamente precisos.',
  'about.techCard.spec.architecture': 'Arquitectura',
  'about.techCard.spec.frameRate': 'Tasa de fotogramas',
  'about.techCard.spec.frameRate.value': 'Interpolación 24 / 60 FPS',
  'about.techCard.spec.consistency': 'Consistencia',
  'about.techCard.spec.consistency.value': 'Alta estabilidad temporal',
  'about.techCard.spec.length': 'Duración',
  'about.techCard.spec.length.value': 'Extensión de bucle infinito',
  'about.techCard.img2img.title': 'Imagen-a-imagen y transferencia de estilo.',
  'about.techCard.img2img.description': 'Usando tecnologías IP-Adapter y T2I-Adapter, logramos transferencia de estilo zero-shot. Sube una imagen de referencia para replicar instantáneamente su composición, iluminación y estilo artístico, liberando posibilidades creativas infinitas.',
  'about.techCard.spec.technology': 'Tecnología',
  'about.techCard.spec.precision': 'Precisión',
  'about.techCard.spec.precision.value': 'Inpainting pixel-perfecto',
  'about.cta.title': '¿Listo para experimentar el futuro?',
  'about.cta.description': 'Únete a las filas de creadores profesionales y libera el potencial definitivo de la IA.',
  'about.cta.button.start': 'Comenzar',
  'about.cta.button.docs': 'Leer documentación',
  
  // Community
  'community.explore.title': 'Explorar comunidades',
  'community.explore.subtitle': 'Descubre inspiración, remezcla flujos de trabajo y conéctate con miles de creadores de IA.',
  'community.posts': '{count} publicaciones',
  'community.empty': 'No hay canales comunitarios',
  'community.loadFailed': 'Error al cargar',
  'community.noPosts': 'Aún no hay publicaciones',
  'community.challenge.loadFailed': 'Error al cargar datos del desafío',
  
  'common.loadFailed': 'Error al cargar',
  'common.operationFailed': 'Operación fallida',
  'common.error': 'Operación fallida',
  'common.publish': 'Publicar',
  'common.back': 'Atrás',
  'common.backToCommunity': 'Volver a la comunidad',
  'common.copy': 'Copiar',
  'common.copied': 'Copiado',
  'common.follow': 'Seguir',
  'common.processing': 'Procesando...',
  'common.viewCount': '{count} visualizaciones',
  'common.loadMore': 'Cargar más',
  'common.search': 'Buscar...',
  'common.notFound': 'No encontrado',
  'common.description': 'Descripción',
  
  'user.followSuccess': 'Seguido con éxito',
  'user.unfollowSuccess': 'Dejado de seguir con éxito',
  'user.following': 'Siguiendo',
  'user.mutual_follow': 'Mutuo',
  
  'post.untitled': 'Creación sin título',
  'post.prompt': 'Prompt',
  'post.negativePrompt': 'Prompt negativo',
  'post.details': 'Detalles',
  'post.model': 'Modelo',
  'post.resolution': 'Resolución',
  'post.steps': 'Pasos',
  'post.cfgScale': 'Escala de guía',
  'post.remix': 'Remix / Probar esto',
  
  'challenge.status.upcoming': 'Próximamente',
  'challenge.status.live': 'En vivo',
  'challenge.status.voting': 'Votación',
  'challenge.status.ended': 'Finalizado',
  'challenge.status.unknown': 'Desconocido',
  'challenge.allChallenges': 'Todos los desafíos',
  'challenge.entriesCount': '{count} participaciones',
  'challenge.tab.submissions': 'Participaciones',
  'challenge.tab.rules': 'Reglas e información',
  'challenge.requirements': 'Requisitos',
  'challenge.req.original': 'Solo creaciones originales.',
  'challenge.req.model': 'Debe usar el modelo: {model}',
  'challenge.req.tags': 'Debe incluir etiquetas:',
  'challenge.req.resolution': 'La resolución debe ser al menos 1024x1024.',
  'challenge.req.nsfw': 'No se permite contenido NSFW.',
  'challenge.timeRemaining': 'Tiempo restante',
  'challenge.startsIn': 'Comienza en',
  'challenge.notStarted': 'Desafío aún no iniciado',
  'challenge.closed': 'Desafío cerrado',
  'challenge.submitEntry': 'Enviar participación',
  'challenge.viewWinners': 'Ver ganadores',
  'challenge.readRulesTip': 'Lee las reglas antes de enviar',
  'challenge.prizePool': 'Premio',
  'challenge.totalValue': 'Valor total',
  'challenge.rank.1st': '1er lugar',
  'challenge.rank.2nd': '2do lugar',
  'challenge.rank.3rd': '3er lugar',
  'challenge.share': 'Compartir desafío',
  'challenge.noEntries': 'Aún no hay participaciones. ¡Sé el primero!',
  'challenge.noChallenges': 'No se encontraron desafíos',
  // MediaTools
  'mediaTools.tab.imageCompress': 'Compresión de imagen',
  'mediaTools.tab.videoCompress': 'Compresión de video',
  'mediaTools.tab.audioCompress': 'Compresión de audio',
  'mediaTools.tab.formatConvert': 'Conversión de formato',
  // ImageCompress
  'imageCompress.title': 'Herramienta profesional de compresión de imágenes',
  'imageCompress.subtitle': 'Compresión inteligente, calidad profesional',
  'imageCompress.upload': 'Subir imágenes',
  'imageCompress.addImages': 'Agregar imágenes',
  'imageCompress.uploadToStart': 'Sube imágenes para comenzar la compresión',
  'imageCompress.settings': 'Configuración',
  'imageCompress.clearAll': 'Limpiar todo',
  'imageCompress.totalSavings': 'Espacio ahorrado',
  'imageCompress.totalSize': 'Tamaño total',
  'imageCompress.quality': 'Calidad',
  'imageCompress.resize': 'Redimensionar',
  'imageCompress.scalePercent': 'Escala %',
  'imageCompress.customPx': 'Px personalizado',
  'imageCompress.presetSize': 'Tamaño predefinido',
  'imageCompress.width': 'Ancho',
  'imageCompress.height': 'Alto',
  'imageCompress.format': 'Formato',
  'imageCompress.format.auto': 'Automático (original)',
  'imageCompress.format.jpeg': 'JPEG (foto)',
  'imageCompress.format.png': 'PNG (sin pérdida)',
  'imageCompress.format.webp': 'WebP (mejor)',
  'imageCompress.pngLossless': 'PNG es sin pérdida. El control deslizante de calidad está oculto.',
  'imageCompress.cacheSettings': 'Configuración de caché',
  'imageCompress.cacheTooltip': 'Cuando está habilitado, las imágenes subidas se guardarán en la caché del navegador y se restaurarán después de actualizar la página.',
  'imageCompress.saveToCache': 'Guardar imágenes en la caché del navegador',
  'imageCompress.batchProcessing': 'Procesamiento por lotes',
  'imageCompress.batchTooltip': 'Cuando está habilitado, la compresión se aplicará a todas las {count} imágenes con la configuración actual.',
  'imageCompress.applyToAll': 'Aplicar configuración a todas las imágenes ({count})',
  'imageCompress.compress': 'Aplicar y comprimir',
  'imageCompress.compressAll': 'Aplicar y comprimir todo ({count})',
  'imageCompress.compressing': 'Comprimiendo...',
  'imageCompress.compressAllProgress': 'Comprimiendo {count} imágenes...',
  'imageCompress.download': 'Descargar imagen',
  'imageCompress.downloadAll': 'Descargar todo ({count})',
  'imageCompress.downloadAllCheckbox': 'Descargar todas las {count} imágenes',
  'imageCompress.original': 'Original',
  'imageCompress.compressed': 'Comprimido',
  // Messages
  'imageCompress.message.compressed': '¡Compresión exitosa!',
  'imageCompress.message.larger': 'El archivo de salida es más grande. Intenta reducir la calidad.',
  'imageCompress.message.failed': 'Error en la compresión',
  'imageCompress.message.batchSuccess': 'Se comprimieron exitosamente {success} imagen(es){failed}',
  'imageCompress.message.batchFailed': 'Todas las compresiones fallaron',
  'imageCompress.message.noImagesToDownload': 'No hay imágenes comprimidas para descargar',
  'imageCompress.message.downloading': 'Descargando {count} imagen(es)...',
  // Preset sizes
  'imageCompress.preset.instagramPost': 'Publicación de Instagram (1:1)',
  'imageCompress.preset.square': 'Cuadrado (1:1)',
  'imageCompress.preset.facebookCover': 'Portada de Facebook (16:9)',
  'imageCompress.preset.twitterHeader': 'Encabezado de Twitter (3:1)',
  'imageCompress.preset.youtubeThumbnail': 'Miniatura de YouTube (16:9)',
  'imageCompress.preset.facebookPost': 'Publicación de Facebook (1.91:1)',
  'imageCompress.preset.instagramStory': 'Historia de Instagram (9:16)',
  'imageCompress.preset.tiktok': 'TikTok (9:16)',
  'imageCompress.preset.4kUHD': '4K UHD (16:9)',
  'imageCompress.preset.2kQHD': '2K QHD (16:9)',
  'imageCompress.preset.fullHD': 'Full HD (16:9)',
  'imageCompress.preset.hd': 'HD (16:9)',
  'imageCompress.preset.landscape16:9': 'Paisaje 16:9',
  'imageCompress.preset.classic4:3': 'Clásico 4:3',
  'imageCompress.preset.photo3:2': 'Foto 3:2',
  'imageCompress.preset.ultrawide21:9': 'Ultra ancho 21:9',
  'imageCompress.preset.a4Portrait': 'A4 Vertical (8.27×11.69")',
  'imageCompress.preset.a4Landscape': 'A4 Horizontal (11.69×8.27")',
  'imageCompress.preset.letterPortrait': 'Letter Vertical (8.5×11")',
  // AudioCompress
  'audioCompress.title': 'Herramienta profesional de compresión de audio',
  'audioCompress.subtitle': 'Compresión basada en navegador, privacidad protegida',
  'audioCompress.upload': 'Subir audio',
  'audioCompress.uploadNew': 'Haga clic para subir nuevo audio',
  'audioCompress.uploadToStart': 'Suba audio para comenzar la compresión',
  'audioCompress.settings': 'Configuración',
  'audioCompress.clearAll': 'Borrar todo',
  'audioCompress.totalSavings': 'Espacio ahorrado',
  'audioCompress.totalSize': 'Tamaño total',
  'audioCompress.audioInfo': 'Info de audio',
  'audioCompress.quality': 'Calidad',
  'audioCompress.bitrate': 'Tasa de bits',
  'audioCompress.bitrate.320': '320 kbps (Máxima calidad)',
  'audioCompress.bitrate.256': '256 kbps (Alta calidad)',
  'audioCompress.bitrate.192': '192 kbps (Calidad estándar)',
  'audioCompress.bitrate.128': '128 kbps (Calidad media)',
  'audioCompress.bitrate.96': '96 kbps (Baja calidad)',
  'audioCompress.bitrate.64': '64 kbps (Mínima calidad)',
  'audioCompress.format': 'Formato',
  'audioCompress.format.mp3': 'MP3 (Recomendado)',
  'audioCompress.format.ogg': 'OGG',
  'audioCompress.format.aac': 'AAC',
  'audioCompress.format.wav': 'WAV',
  'audioCompress.sampleRate': 'Tasa de muestreo',
  'audioCompress.sampleRate.48000': '48000 Hz',
  'audioCompress.sampleRate.44100': '44100 Hz (Calidad CD)',
  'audioCompress.sampleRate.32000': '32000 Hz',
  'audioCompress.sampleRate.22050': '22050 Hz',
  'audioCompress.sampleRate.16000': '16000 Hz',
  'audioCompress.compress': 'Iniciar compresión',
  'audioCompress.compressing': 'Comprimiendo...',
  'audioCompress.download': 'Descargar audio',
  // AudioCompress Messages
  'audioCompress.message.compressed': '¡Compresión exitosa!',
  'audioCompress.message.failed': 'Compresión fallida, intente nuevamente',
  'audioCompress.message.invalidFile': '¡Seleccione un archivo de audio!',
  'audioCompress.message.loadError': 'Error al cargar el archivo de audio',
  
  // Settings
  'settings.title': 'Configuración del Sistema',
  'settings.description': 'Personalice su experiencia en la plataforma de generación de IA',
  'settings.notifications.title': 'Configuración de Notificaciones',
  'settings.notifications.description': 'Administre cómo recibe las notificaciones',
  'settings.notifications.email': 'Notificaciones por Email',
  'settings.notifications.emailDesc': 'Reciba actualizaciones importantes y correos de finalización de tareas',
  'settings.notifications.push': 'Notificaciones Push',
  'settings.notifications.pushDesc': 'Reciba mensajes push en tiempo real',
  'settings.notifications.sound': 'Alertas de Sonido',
  'settings.notifications.soundDesc': 'Reproducir un sonido cuando lleguen notificaciones',
  'settings.notifications.volume': 'Volumen de Notificación',
  'settings.notifications.volumeDesc': 'Ajuste el volumen de los sonidos de notificación',
  'settings.notifications.marketing': 'Marketing',
  'settings.notifications.marketingDesc': 'Reciba eventos de la plataforma e información promocional',
  'settings.interface.title': 'Apariencia de la Interfaz',
  'settings.interface.description': 'Personalice la visualización de la interfaz',
  'settings.interface.theme': 'Modo de Tema',
  'settings.interface.themeDesc': 'Elija su tema de interfaz preferido',
  'settings.interface.language': 'Idioma',
  'settings.interface.languageDesc': 'Seleccione el idioma de visualización de la interfaz',
  'settings.interface.animation': 'Efectos de Animación',
  'settings.interface.animationDesc': 'Habilite animaciones de transición de interfaz',
  'settings.interface.tips': 'Consejos para Principiantes',
  'settings.interface.tipsDesc': 'Mostrar guías de funciones y consejos',
  'settings.theme.light': 'Claro',
  'settings.theme.dark': 'Oscuro',
  'settings.theme.auto': 'Automático',
  'settings.ai.title': 'Configuración de Generación de IA',
  'settings.ai.description': 'Optimice los efectos y el rendimiento de generación de IA',
  'settings.ai.autoOptimize': 'Optimización Inteligente',
  'settings.ai.autoOptimizeDesc': 'La IA optimiza automáticamente los parámetros de generación',
  'settings.ai.quality': 'Calidad de Generación',
  'settings.ai.qualityDesc': 'Balance entre velocidad y calidad',
  'settings.ai.cloudSync': 'Sincronización en la Nube',
  'settings.ai.cloudSyncDesc': 'Sincronizar automáticamente obras en la nube',
  'settings.ai.autoSave': 'Guardado Automático',
  'settings.ai.autoSaveDesc': 'Guardar automáticamente resultados después de la generación',
  'settings.ai.safetyFilter': 'Filtro de Seguridad de Contenido',
  'settings.ai.safetyFilterDesc': 'Filtrar automáticamente contenido inapropiado',
  'settings.ai.watermark': 'Agregar Marca de Agua',
  'settings.ai.watermarkDesc': 'Agregar automáticamente marca de agua a obras generadas',
  'settings.ai.promptSuggestions': 'Sugerencias de Prompt',
  'settings.ai.promptSuggestionsDesc': 'Recomendaciones inteligentes para optimización de prompts',
  'settings.quality.fast': 'Rápido',
  'settings.quality.balanced': 'Equilibrado',
  'settings.quality.high': 'Alta Calidad',
  'settings.privacy.title': 'Privacidad y Seguridad',
  'settings.privacy.description': 'Proteja su información personal',
  'settings.privacy.profile': 'Visibilidad del Perfil',
  'settings.privacy.profileDesc': 'Permitir que otros usuarios vean su perfil',
  'settings.privacy.activity': 'Mostrar Estado de Actividad',
  'settings.privacy.activityDesc': 'Permitir que amigos vean su estado en línea',
  'settings.privacy.analytics': 'Recopilación de Datos Analíticos',
  'settings.privacy.analyticsDesc': 'Ayúdenos a mejorar la experiencia del producto',
  'settings.privacy.showWorks': 'Visibilidad de Obras',
  'settings.privacy.showWorksDesc': 'Permitir que otros usuarios vean sus obras',
  'settings.privacy.allowComments': 'Permitir Comentarios',
  'settings.privacy.allowCommentsDesc': 'Permitir que otros usuarios comenten sus obras',
  'settings.privacy.allowDownload': 'Permitir Descarga',
  'settings.privacy.allowDownloadDesc': 'Permitir que otros usuarios descarguen sus obras',
  'settings.performance.title': 'Optimización de Rendimiento',
  'settings.performance.description': 'Ajuste el rendimiento del sistema y el uso de recursos',
  'settings.performance.hardware': 'Aceleración por Hardware',
  'settings.performance.hardwareDesc': 'Usar aceleración GPU para renderizado',
  'settings.performance.preview': 'Calidad de Vista Previa',
  'settings.performance.previewDesc': 'Nivel de calidad de imágenes de vista previa',
  'settings.performance.autoClean': 'Limpiar Caché Automáticamente',
  'settings.performance.autoCleanDesc': 'Limpiar archivos temporales regularmente',
  'settings.performance.imageCompression': 'Compresión de Imágenes',
  'settings.performance.imageCompressionDesc': 'Comprimir automáticamente imágenes cargadas',
  'settings.performance.lazyLoading': 'Carga Diferida',
  'settings.performance.lazyLoadingDesc': 'Retrasar la carga del contenido de la página',
  'settings.preview.low': 'Bajo',
  'settings.preview.medium': 'Medio',
  'settings.preview.high': 'Alto',
  'settings.workflow.title': 'Configuración de Flujo de Trabajo',
  'settings.workflow.description': 'Personalice el flujo de trabajo de generación de IA',
  'settings.workflow.resolution': 'Resolución Predeterminada',
  'settings.workflow.resolutionDesc': 'Tamaño predeterminado para generación de imágenes',
  'settings.workflow.saveHistory': 'Guardar Historial',
  'settings.workflow.saveHistoryDesc': 'Guardar parámetros de generación e historial de prompts',
  'settings.workflow.autoTag': 'Etiquetas Inteligentes',
  'settings.workflow.autoTagDesc': 'Agregar automáticamente etiquetas a las obras',
  'settings.workflow.template': 'Función de Plantilla',
  'settings.workflow.templateDesc': 'Habilitar plantillas de flujo de trabajo',
  'settings.file.title': 'Gestión de Archivos',
  'settings.file.description': 'Administre el almacenamiento y respaldo de archivos',
  'settings.file.autoBackup': 'Respaldo Automático',
  'settings.file.autoBackupDesc': 'Respaldar automáticamente archivos importantes',
  'settings.file.backupFrequency': 'Frecuencia de Respaldo',
  'settings.file.backupFrequencyDesc': 'Seleccione la frecuencia de respaldo',
  'settings.file.realtime': 'Tiempo Real',
  'settings.file.daily': 'Diario',
  'settings.file.weekly': 'Semanal',
  'settings.file.autoOrganize': 'Organización Inteligente',
  'settings.file.autoOrganizeDesc': 'Categorizar y organizar archivos automáticamente',
  'settings.file.defaultFormat': 'Formato Predeterminado',
  'settings.file.defaultFormatDesc': 'Formato predeterminado para guardar archivos',
  'settings.social.title': 'Interacción Social',
  'settings.social.description': 'Administre funciones sociales y permisos de interacción',
  'settings.social.allowFollow': 'Permitir Seguir',
  'settings.social.allowFollowDesc': 'Permitir que otros usuarios lo sigan',
  'settings.social.allowMessage': 'Permitir Mensajes',
  'settings.social.allowMessageDesc': 'Permitir que otros usuarios le envíen mensajes',
  'settings.social.likeNotify': 'Notificaciones de Me Gusta',
  'settings.social.likeNotifyDesc': 'Notificar cuando reciban me gusta las obras',
  'settings.social.mentionNotify': 'Notificaciones de Mención',
  'settings.social.mentionNotifyDesc': 'Recibir notificaciones cuando lo mencionen',
  'settings.security.title': 'Seguridad de la Cuenta',
  'settings.security.description': 'Mejore la protección de seguridad de la cuenta',
  'settings.security.twoFactor': 'Autenticación de Dos Factores',
  'settings.security.twoFactorDesc': 'Agregue una capa adicional de verificación de seguridad',
  'settings.security.loginNotify': 'Notificaciones de Inicio de Sesión',
  'settings.security.loginNotifyDesc': 'Notificar al iniciar sesión desde nuevos dispositivos',
  'settings.security.deviceVerify': 'Verificación de Dispositivo',
  'settings.security.deviceVerifyDesc': 'Los dispositivos no autorizados requieren verificación',
  'settings.security.autoLogout': 'Cerrar Sesión Automáticamente en Inactividad',
  'settings.security.autoLogoutDesc': 'Cerrar sesión automáticamente después de inactividad prolongada',
  'settings.button.save': 'Guardar Configuración',
  'settings.button.reset': 'Restablecer a Predeterminado',
  'settings.badge.on': 'Activado',
  'settings.badge.recommended': 'Recomendado',
  'settings.message.saveSuccess': 'Configuración guardada',
  'settings.message.autoSaved': 'Configuración guardada automáticamente',
  'settings.message.saveFailed': 'Error al guardar, intente nuevamente',
  'settings.message.resetSuccess': 'Configuración restablecida a predeterminada',
  'settings.autoSaveHint': 'La configuración se guardará automáticamente',
  'settings.confirm.resetTitle': 'Confirmar Restablecimiento',
  'settings.confirm.resetContent': '¿Está seguro de que desea restablecer toda la configuración a los valores predeterminados?',
  'settings.confirm.reset': 'Restablecer',
  'settings.confirm.cancel': 'Cancelar',

  // Prompt Version History
  'prompt.version.label.prompt': 'Prompt',
  'prompt.version.label.negativePrompt': 'Prompt Negativo',
  'prompt.version.label.result': 'Resultado',
}; 